export function OnboardImage3() {
  return (
    <svg style={{ width: '100%' }} viewBox='0 0 390 494' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='390' height='494' fill='var(--ion-background-color)' />
      <g opacity='0.6'>
        <mask id='path-1-inside-1_3383_10956' fill='var(--white)'>
          <path d='M26 43H59.9V76.9H26V43Z' />
        </mask>
        <g
          clipPath='url(#paint0_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-1-inside-1_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 76.9V77.9H60.9V76.9H59.9ZM26 76.9H25V77.9H26V76.9ZM58.9 43V76.9H60.9V43H58.9ZM59.9 75.9H26V77.9H59.9V75.9ZM27 76.9V43H25V76.9H27Z'
          mask='url(#path-1-inside-1_3383_10956)'
        />
        <path
          d='M42.0117 63V55.7168H41.918L39.7676 57.2754V56.1621L42.0176 54.5449H43.0664V63H42.0117Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-4-inside-2_3383_10956' fill='var(--white)'>
          <path d='M59.9 43H93.8V76.9H59.9V43Z' />
        </mask>
        <g
          clipPath='url(#paint1_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-4-inside-2_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 76.9V77.9H94.8V76.9H93.8ZM92.8 43V76.9H94.8V43H92.8ZM93.8 75.9H59.9V77.9H93.8V75.9Z'
          mask='url(#path-4-inside-2_3383_10956)'
        />
        <path
          d='M77.3333 57V60.3333M77.3333 60.3333V63.6667M77.3333 60.3333H74M77.3333 60.3333H80.6667'
          stroke='var(--black)'
          strokeOpacity='0.05'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-7-inside-3_3383_10956' fill='var(--white)'>
          <path d='M93.8 43H127.7V76.9H93.8V43Z' />
        </mask>
        <g
          clipPath='url(#paint2_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-7-inside-3_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 76.9V77.9H128.7V76.9H127.7ZM126.7 43V76.9H128.7V43H126.7ZM127.7 75.9H93.8V77.9H127.7V75.9Z'
          mask='url(#path-7-inside-3_3383_10956)'
        />
        <path d='M106.467 59H113.133' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-10-inside-4_3383_10956' fill='var(--white)'>
          <path d='M127.7 43H161.6V76.9H127.7V43Z' />
        </mask>
        <g
          clipPath='url(#paint3_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-10-inside-4_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 76.9V77.9H162.6V76.9H161.6ZM160.6 43V76.9H162.6V43H160.6ZM161.6 75.9H127.7V77.9H161.6V75.9Z'
          mask='url(#path-10-inside-4_3383_10956)'
        />
        <path
          d='M144.773 64.1992C144.148 64.1992 143.613 64.0195 143.168 63.6602C142.727 63.3008 142.387 62.791 142.148 62.1309C141.91 61.4668 141.791 60.6816 141.791 59.7754V59.7637C141.791 58.8574 141.91 58.0742 142.148 57.4141C142.387 56.7539 142.727 56.2441 143.168 55.8848C143.613 55.5254 144.148 55.3457 144.773 55.3457C145.398 55.3457 145.934 55.5254 146.379 55.8848C146.824 56.2441 147.166 56.7539 147.404 57.4141C147.646 58.0742 147.768 58.8574 147.768 59.7637V59.7754C147.768 60.6816 147.646 61.4668 147.404 62.1309C147.166 62.791 146.824 63.3008 146.379 63.6602C145.934 64.0195 145.398 64.1992 144.773 64.1992ZM144.773 63.2793C145.18 63.2793 145.525 63.1367 145.811 62.8516C146.1 62.5664 146.32 62.1621 146.473 61.6387C146.629 61.1152 146.707 60.4941 146.707 59.7754V59.7637C146.707 59.0449 146.629 58.4258 146.473 57.9062C146.32 57.3828 146.1 56.9805 145.811 56.6992C145.525 56.4141 145.18 56.2715 144.773 56.2715C144.371 56.2715 144.025 56.4141 143.736 56.6992C143.451 56.9805 143.232 57.3828 143.08 57.9062C142.928 58.4258 142.852 59.0449 142.852 59.7637V59.7754C142.852 60.4941 142.928 61.1152 143.08 61.6387C143.232 62.1621 143.451 62.5664 143.736 62.8516C144.025 63.1367 144.371 63.2793 144.773 63.2793Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-13-inside-5_3383_10956' fill='var(--white)'>
          <path d='M161.6 43H195.5V76.9H161.6V43Z' />
        </mask>
        <g
          clipPath='url(#paint4_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-13-inside-5_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 76.9V77.9H196.5V76.9H195.5ZM194.5 43V76.9H196.5V43H194.5ZM195.5 75.9H161.6V77.9H195.5V75.9Z'
          mask='url(#path-13-inside-5_3383_10956)'
        />
        <path
          d='M177.612 63V55.7168H177.518L175.368 57.2754V56.1621L177.618 54.5449H178.666V63H177.612Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-16-inside-6_3383_10956' fill='var(--white)'>
          <path d='M195.5 43H229.4V76.9H195.5V43Z' />
        </mask>
        <g
          clipPath='url(#paint5_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-16-inside-6_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 76.9V77.9H230.4V76.9H229.4ZM228.4 43V76.9H230.4V43H228.4ZM229.4 75.9H195.5V77.9H229.4V75.9Z'
          mask='url(#path-16-inside-6_3383_10956)'
        />
        <rect x='217' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='212.2' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='209.8' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='207.4' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='205' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='214.6' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='214.6' y='56.3999' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 214.6 63.6001)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <rect x='212.2' y='54' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 217 61.2002)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <mask id='path-28-inside-7_3383_10956' fill='var(--white)'>
          <path d='M229.4 43H263.3V76.9H229.4V43Z' />
        </mask>
        <g
          clipPath='url(#paint6_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-28-inside-7_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 76.9V77.9H264.3V76.9H263.3ZM262.3 43V76.9H264.3V43H262.3ZM263.3 75.9H229.4V77.9H263.3V75.9Z'
          mask='url(#path-28-inside-7_3383_10956)'
        />
        <path d='M242.067 59H248.733' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-31-inside-8_3383_10956' fill='var(--white)'>
          <path d='M263.3 43H297.2V76.9H263.3V43Z' />
        </mask>
        <g
          clipPath='url(#paint7_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-31-inside-8_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 76.9V77.9H298.2V76.9H297.2ZM296.2 43V76.9H298.2V43H296.2ZM297.2 75.9H263.3V77.9H297.2V75.9Z'
          mask='url(#path-31-inside-8_3383_10956)'
        />
        <path
          d='M279.073 63.1992C278.448 63.1992 277.913 63.0195 277.468 62.6602C277.027 62.3008 276.687 61.791 276.448 61.1309C276.21 60.4668 276.091 59.6816 276.091 58.7754V58.7637C276.091 57.8574 276.21 57.0742 276.448 56.4141C276.687 55.7539 277.027 55.2441 277.468 54.8848C277.913 54.5254 278.448 54.3457 279.073 54.3457C279.698 54.3457 280.234 54.5254 280.679 54.8848C281.124 55.2441 281.466 55.7539 281.704 56.4141C281.947 57.0742 282.068 57.8574 282.068 58.7637V58.7754C282.068 59.6816 281.947 60.4668 281.704 61.1309C281.466 61.791 281.124 62.3008 280.679 62.6602C280.234 63.0195 279.698 63.1992 279.073 63.1992ZM279.073 62.2793C279.48 62.2793 279.825 62.1367 280.111 61.8516C280.4 61.5664 280.62 61.1621 280.773 60.6387C280.929 60.1152 281.007 59.4941 281.007 58.7754V58.7637C281.007 58.0449 280.929 57.4258 280.773 56.9062C280.62 56.3828 280.4 55.9805 280.111 55.6992C279.825 55.4141 279.48 55.2715 279.073 55.2715C278.671 55.2715 278.325 55.4141 278.036 55.6992C277.751 55.9805 277.532 56.3828 277.38 56.9062C277.228 57.4258 277.152 58.0449 277.152 58.7637V58.7754C277.152 59.4941 277.228 60.1152 277.38 60.6387C277.532 61.1621 277.751 61.5664 278.036 61.8516C278.325 62.1367 278.671 62.2793 279.073 62.2793Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-34-inside-9_3383_10956' fill='var(--white)'>
          <path d='M297.2 43H331.1V76.9H297.2V43Z' />
        </mask>
        <g
          clipPath='url(#paint8_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-34-inside-9_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 76.9V77.9H332.1V76.9H331.1ZM330.1 43V76.9H332.1V43H330.1ZM331.1 75.9H297.2V77.9H331.1V75.9Z'
          mask='url(#path-34-inside-9_3383_10956)'
        />
        <path
          d='M313.212 63V55.7168H313.118L310.968 57.2754V56.1621L313.218 54.5449H314.266V63H313.212Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-37-inside-10_3383_10956' fill='var(--white)'>
          <path d='M331.1 43H365V76.9H331.1V43Z' />
        </mask>
        <g
          clipPath='url(#paint9_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-37-inside-10_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 59.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 76.9V77.9H366V76.9H365ZM364 43V76.9H366V43H364ZM365 75.9H331.1V77.9H365V75.9Z'
          mask='url(#path-37-inside-10_3383_10956)'
        />
        <rect x='353' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='348.2' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='345.8' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='343.4' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='341' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='350.6' y='58.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='350.6' y='56.3999' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 350.6 63.6001)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <rect x='348.2' y='54' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 353 61.2002)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <mask id='path-49-inside-11_3383_10956' fill='var(--white)'>
          <path d='M26 77H59.9V110.9H26V77Z' />
        </mask>
        <g
          clipPath='url(#paint10_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-49-inside-11_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 110.9V111.9H60.9V110.9H59.9ZM26 110.9H25V111.9H26V110.9ZM58.9 77V110.9H60.9V77H58.9ZM59.9 109.9H26V111.9H59.9V109.9ZM27 110.9V77H25V110.9H27Z'
          mask='url(#path-49-inside-11_3383_10956)'
        />
        <path
          d='M42.0117 97V89.7168H41.918L39.7676 91.2754V90.1621L42.0176 88.5449H43.0664V97H42.0117Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-52-inside-12_3383_10956' fill='var(--white)'>
          <path d='M59.9 77H93.8V110.9H59.9V77Z' />
        </mask>
        <g
          clipPath='url(#paint11_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-52-inside-12_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 110.9V111.9H94.8V110.9H93.8ZM92.8 77V110.9H94.8V77H92.8ZM93.8 109.9H59.9V111.9H93.8V109.9Z'
          mask='url(#path-52-inside-12_3383_10956)'
        />
        <path
          d='M75.9 89.6665V92.9998M75.9 92.9998V96.3332M75.9 92.9998H72.5667M75.9 92.9998H79.2334'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-55-inside-13_3383_10956' fill='var(--white)'>
          <path d='M93.8 77H127.7V110.9H93.8V77Z' />
        </mask>
        <g
          clipPath='url(#paint12_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-55-inside-13_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 110.9V111.9H128.7V110.9H127.7ZM126.7 77V110.9H128.7V77H126.7ZM127.7 109.9H93.8V111.9H127.7V109.9Z'
          mask='url(#path-55-inside-13_3383_10956)'
        />
        <path d='M106.467 93H113.133' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-58-inside-14_3383_10956' fill='var(--white)'>
          <path d='M127.7 77H161.6V110.9H127.7V77Z' />
        </mask>
        <g
          clipPath='url(#paint13_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-58-inside-14_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 110.9V111.9H162.6V110.9H161.6ZM160.6 77V110.9H162.6V77H160.6ZM161.6 109.9H127.7V111.9H161.6V109.9Z'
          mask='url(#path-58-inside-14_3383_10956)'
        />
        <path
          d='M143.473 97.1992C142.848 97.1992 142.313 97.0195 141.868 96.6602C141.427 96.3008 141.087 95.791 140.848 95.1309C140.61 94.4668 140.491 93.6816 140.491 92.7754V92.7637C140.491 91.8574 140.61 91.0742 140.848 90.4141C141.087 89.7539 141.427 89.2441 141.868 88.8848C142.313 88.5254 142.848 88.3457 143.473 88.3457C144.098 88.3457 144.634 88.5254 145.079 88.8848C145.524 89.2441 145.866 89.7539 146.104 90.4141C146.346 91.0742 146.468 91.8574 146.468 92.7637V92.7754C146.468 93.6816 146.346 94.4668 146.104 95.1309C145.866 95.791 145.524 96.3008 145.079 96.6602C144.634 97.0195 144.098 97.1992 143.473 97.1992ZM143.473 96.2793C143.88 96.2793 144.225 96.1367 144.511 95.8516C144.8 95.5664 145.02 95.1621 145.173 94.6387C145.329 94.1152 145.407 93.4941 145.407 92.7754V92.7637C145.407 92.0449 145.329 91.4258 145.173 90.9062C145.02 90.3828 144.8 89.9805 144.511 89.6992C144.225 89.4141 143.88 89.2715 143.473 89.2715C143.071 89.2715 142.725 89.4141 142.436 89.6992C142.151 89.9805 141.932 90.3828 141.78 90.9062C141.628 91.4258 141.552 92.0449 141.552 92.7637V92.7754C141.552 93.4941 141.628 94.1152 141.78 94.6387C141.932 95.1621 142.151 95.5664 142.436 95.8516C142.725 96.1367 143.071 96.2793 143.473 96.2793Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-61-inside-15_3383_10956' fill='var(--white)'>
          <path d='M161.6 77H195.5V110.9H161.6V77Z' />
        </mask>
        <g
          clipPath='url(#paint14_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-61-inside-15_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 110.9V111.9H196.5V110.9H195.5ZM194.5 77V110.9H196.5V77H194.5ZM195.5 109.9H161.6V111.9H195.5V109.9Z'
          mask='url(#path-61-inside-15_3383_10956)'
        />
        <rect x='174' y='86.4922' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='174' y='96.5029' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='178.996' y='91.4966' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <mask id='path-66-inside-16_3383_10956' fill='var(--white)'>
          <path d='M195.5 77H229.4V110.9H195.5V77Z' />
        </mask>
        <g
          clipPath='url(#paint15_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-66-inside-16_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 110.9V111.9H230.4V110.9H229.4ZM228.4 77V110.9H230.4V77H228.4ZM229.4 109.9H195.5V111.9H229.4V109.9Z'
          mask='url(#path-66-inside-16_3383_10956)'
        />
        <path
          d='M212 90.6665V93.9998M212 93.9998V97.3332M212 93.9998H208.667M212 93.9998H215.333'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-69-inside-17_3383_10956' fill='var(--white)'>
          <path d='M229.4 77H263.3V110.9H229.4V77Z' />
        </mask>
        <g
          clipPath='url(#paint16_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-69-inside-17_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 110.9V111.9H264.3V110.9H263.3ZM262.3 77V110.9H264.3V77H262.3ZM263.3 109.9H229.4V111.9H263.3V109.9Z'
          mask='url(#path-69-inside-17_3383_10956)'
        />
        <rect x='251.3' y='92.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='246.5' y='92.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='244.1' y='92.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='241.7' y='92.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='239.3' y='92.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='248.9' y='92.8003' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='248.9' y='90.3999' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 248.9 97.6001)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <rect x='246.5' y='88' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 251.3 95.2002)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <mask id='path-81-inside-18_3383_10956' fill='var(--white)'>
          <path d='M263.3 77H297.2V110.9H263.3V77Z' />
        </mask>
        <g
          clipPath='url(#paint17_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-81-inside-18_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 110.9V111.9H298.2V110.9H297.2ZM296.2 77V110.9H298.2V77H296.2ZM297.2 109.9H263.3V111.9H297.2V109.9Z'
          mask='url(#path-81-inside-18_3383_10956)'
        />
        <path d='M275.967 93H282.633' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-84-inside-19_3383_10956' fill='var(--white)'>
          <path d='M297.2 77H331.1V110.9H297.2V77Z' />
        </mask>
        <g
          clipPath='url(#paint18_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-84-inside-19_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 110.9V111.9H332.1V110.9H331.1ZM330.1 77V110.9H332.1V77H330.1ZM331.1 109.9H297.2V111.9H331.1V109.9Z'
          mask='url(#path-84-inside-19_3383_10956)'
        />
        <path
          d='M312.973 97.1992C312.348 97.1992 311.813 97.0195 311.368 96.6602C310.927 96.3008 310.587 95.791 310.348 95.1309C310.11 94.4668 309.991 93.6816 309.991 92.7754V92.7637C309.991 91.8574 310.11 91.0742 310.348 90.4141C310.587 89.7539 310.927 89.2441 311.368 88.8848C311.813 88.5254 312.348 88.3457 312.973 88.3457C313.598 88.3457 314.134 88.5254 314.579 88.8848C315.024 89.2441 315.366 89.7539 315.604 90.4141C315.846 91.0742 315.968 91.8574 315.968 92.7637V92.7754C315.968 93.6816 315.846 94.4668 315.604 95.1309C315.366 95.791 315.024 96.3008 314.579 96.6602C314.134 97.0195 313.598 97.1992 312.973 97.1992ZM312.973 96.2793C313.38 96.2793 313.725 96.1367 314.011 95.8516C314.3 95.5664 314.52 95.1621 314.673 94.6387C314.829 94.1152 314.907 93.4941 314.907 92.7754V92.7637C314.907 92.0449 314.829 91.4258 314.673 90.9062C314.52 90.3828 314.3 89.9805 314.011 89.6992C313.725 89.4141 313.38 89.2715 312.973 89.2715C312.571 89.2715 312.225 89.4141 311.936 89.6992C311.651 89.9805 311.432 90.3828 311.28 90.9062C311.128 91.4258 311.052 92.0449 311.052 92.7637V92.7754C311.052 93.4941 311.128 94.1152 311.28 94.6387C311.432 95.1621 311.651 95.5664 311.936 95.8516C312.225 96.1367 312.571 96.2793 312.973 96.2793Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-87-inside-20_3383_10956' fill='var(--white)'>
          <path d='M331.1 77H365V110.9H331.1V77Z' />
        </mask>
        <g
          clipPath='url(#paint19_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-87-inside-20_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 93.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 110.9V111.9H366V110.9H365ZM364 77V110.9H366V77H364ZM365 109.9H331.1V111.9H365V109.9Z'
          mask='url(#path-87-inside-20_3383_10956)'
        />
        <path
          d='M347.112 97V89.7168H347.018L344.868 91.2754V90.1621L347.118 88.5449H348.166V97H347.112Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-90-inside-21_3383_10956' fill='var(--white)'>
          <path d='M26 111H59.9V144.9H26V111Z' />
        </mask>
        <g
          clipPath='url(#paint20_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-90-inside-21_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 144.9V145.9H60.9V144.9H59.9ZM26 144.9H25V145.9H26V144.9ZM58.9 111V144.9H60.9V111H58.9ZM59.9 143.9H26V145.9H59.9V143.9ZM27 144.9V111H25V144.9H27Z'
          mask='url(#path-90-inside-21_3383_10956)'
        />
        <path
          d='M42.0117 131V123.717H41.918L39.7676 125.275V124.162L42.0176 122.545H43.0664V131H42.0117Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-93-inside-22_3383_10956' fill='var(--white)'>
          <path d='M59.9 111H93.8V144.9H59.9V111Z' />
        </mask>
        <g
          clipPath='url(#paint21_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-93-inside-22_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 144.9V145.9H94.8V144.9H93.8ZM92.8 111V144.9H94.8V111H92.8ZM93.8 143.9H59.9V145.9H93.8V143.9Z'
          mask='url(#path-93-inside-22_3383_10956)'
        />
        <path
          d='M75.9 123.667V127M75.9 127V130.333M75.9 127H72.5667M75.9 127H79.2334'
          stroke='var(--black)'
          strokeOpacity='0.1'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-96-inside-23_3383_10956' fill='var(--white)'>
          <path d='M93.8 111H127.7V144.9H93.8V111Z' />
        </mask>
        <g
          clipPath='url(#paint22_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-96-inside-23_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 144.9V145.9H128.7V144.9H127.7ZM126.7 111V144.9H128.7V111H126.7ZM127.7 143.9H93.8V145.9H127.7V143.9Z'
          mask='url(#path-96-inside-23_3383_10956)'
        />
        <path d='M106.467 127H113.133' stroke='var(--black)' strokeOpacity='0.1' strokeLinecap='square' />
        <mask id='path-99-inside-24_3383_10956' fill='var(--white)'>
          <path d='M127.7 111H161.6V144.9H127.7V111Z' />
        </mask>
        <g
          clipPath='url(#paint23_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-99-inside-24_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 144.9V145.9H162.6V144.9H161.6ZM160.6 111V144.9H162.6V111H160.6ZM161.6 143.9H127.7V145.9H161.6V143.9Z'
          mask='url(#path-99-inside-24_3383_10956)'
        />
        <path d='M140.367 127H147.033' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-102-inside-25_3383_10956' fill='var(--white)'>
          <path d='M161.6 111H195.5V144.9H161.6V111Z' />
        </mask>
        <g
          clipPath='url(#paint24_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-102-inside-25_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 144.9V145.9H196.5V144.9H195.5ZM194.5 111V144.9H196.5V111H194.5ZM195.5 143.9H161.6V145.9H195.5V143.9Z'
          mask='url(#path-102-inside-25_3383_10956)'
        />
        <path
          d='M177.373 131.199C176.748 131.199 176.213 131.02 175.768 130.66C175.327 130.301 174.987 129.791 174.748 129.131C174.51 128.467 174.391 127.682 174.391 126.775V126.764C174.391 125.857 174.51 125.074 174.748 124.414C174.987 123.754 175.327 123.244 175.768 122.885C176.213 122.525 176.748 122.346 177.373 122.346C177.998 122.346 178.534 122.525 178.979 122.885C179.424 123.244 179.766 123.754 180.004 124.414C180.246 125.074 180.368 125.857 180.368 126.764V126.775C180.368 127.682 180.246 128.467 180.004 129.131C179.766 129.791 179.424 130.301 178.979 130.66C178.534 131.02 177.998 131.199 177.373 131.199ZM177.373 130.279C177.78 130.279 178.125 130.137 178.411 129.852C178.7 129.566 178.92 129.162 179.073 128.639C179.229 128.115 179.307 127.494 179.307 126.775V126.764C179.307 126.045 179.229 125.426 179.073 124.906C178.92 124.383 178.7 123.98 178.411 123.699C178.125 123.414 177.78 123.271 177.373 123.271C176.971 123.271 176.625 123.414 176.336 123.699C176.051 123.98 175.832 124.383 175.68 124.906C175.528 125.426 175.452 126.045 175.452 126.764V126.775C175.452 127.494 175.528 128.115 175.68 128.639C175.832 129.162 176.051 129.566 176.336 129.852C176.625 130.137 176.971 130.279 177.373 130.279Z'
          fill='var(--black)'
          fillOpacity='0.1'
        />
        <mask id='path-105-inside-26_3383_10956' fill='var(--white)'>
          <path d='M195.5 111H229.4V144.9H195.5V111Z' />
        </mask>
        <g
          clipPath='url(#paint25_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-105-inside-26_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 144.9V145.9H230.4V144.9H229.4ZM228.4 111V144.9H230.4V111H228.4ZM229.4 143.9H195.5V145.9H229.4V143.9Z'
          mask='url(#path-105-inside-26_3383_10956)'
        />
        <path
          d='M211.512 131V123.717H211.418L209.268 125.275V124.162L211.518 122.545H212.566V131H211.512Z'
          fill='var(--black)'
          fillOpacity='0.1'
        />
        <mask id='path-108-inside-27_3383_10956' fill='var(--white)'>
          <path d='M229.4 111H263.3V144.9H229.4V111Z' />
        </mask>
        <g
          clipPath='url(#paint26_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-108-inside-27_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 144.9V145.9H264.3V144.9H263.3ZM262.3 111V144.9H264.3V111H262.3ZM263.3 143.9H229.4V145.9H263.3V143.9Z'
          mask='url(#path-108-inside-27_3383_10956)'
        />
        <rect x='241' y='120.492' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='241' y='130.503' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='245.996' y='125.497' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <mask id='path-113-inside-28_3383_10956' fill='var(--white)'>
          <path d='M263.3 111H297.2V144.9H263.3V111Z' />
        </mask>
        <g
          clipPath='url(#paint27_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-113-inside-28_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 144.9V145.9H298.2V144.9H297.2ZM296.2 111V144.9H298.2V111H296.2ZM297.2 143.9H263.3V145.9H297.2V143.9Z'
          mask='url(#path-113-inside-28_3383_10956)'
        />
        <path
          d='M279.073 131.199C278.448 131.199 277.913 131.02 277.468 130.66C277.027 130.301 276.687 129.791 276.448 129.131C276.21 128.467 276.091 127.682 276.091 126.775V126.764C276.091 125.857 276.21 125.074 276.448 124.414C276.687 123.754 277.027 123.244 277.468 122.885C277.913 122.525 278.448 122.346 279.073 122.346C279.698 122.346 280.234 122.525 280.679 122.885C281.124 123.244 281.466 123.754 281.704 124.414C281.947 125.074 282.068 125.857 282.068 126.764V126.775C282.068 127.682 281.947 128.467 281.704 129.131C281.466 129.791 281.124 130.301 280.679 130.66C280.234 131.02 279.698 131.199 279.073 131.199ZM279.073 130.279C279.48 130.279 279.825 130.137 280.111 129.852C280.4 129.566 280.62 129.162 280.773 128.639C280.929 128.115 281.007 127.494 281.007 126.775V126.764C281.007 126.045 280.929 125.426 280.773 124.906C280.62 124.383 280.4 123.98 280.111 123.699C279.825 123.414 279.48 123.271 279.073 123.271C278.671 123.271 278.325 123.414 278.036 123.699C277.751 123.98 277.532 124.383 277.38 124.906C277.228 125.426 277.152 126.045 277.152 126.764V126.775C277.152 127.494 277.228 128.115 277.38 128.639C277.532 129.162 277.751 129.566 278.036 129.852C278.325 130.137 278.671 130.279 279.073 130.279Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-116-inside-29_3383_10956' fill='var(--white)'>
          <path d='M297.2 111H331.1V144.9H297.2V111Z' />
        </mask>
        <g
          clipPath='url(#paint28_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-116-inside-29_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 144.9V145.9H332.1V144.9H331.1ZM330.1 111V144.9H332.1V111H330.1ZM331.1 143.9H297.2V145.9H331.1V143.9Z'
          mask='url(#path-116-inside-29_3383_10956)'
        />
        <rect x='319.1' y='126.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='314.3' y='126.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='311.9' y='126.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='309.5' y='126.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='307.1' y='126.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='316.7' y='126.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='316.7' y='124.4' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 316.7 131.6)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <rect x='314.3' y='122' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 319.1 129.2)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <mask id='path-128-inside-30_3383_10956' fill='var(--white)'>
          <path d='M331.1 111H365V144.9H331.1V111Z' />
        </mask>
        <g
          clipPath='url(#paint29_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-128-inside-30_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 127.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 144.9V145.9H366V144.9H365ZM364 111V144.9H366V111H364ZM365 143.9H331.1V145.9H365V143.9Z'
          mask='url(#path-128-inside-30_3383_10956)'
        />
        <path
          d='M347.112 131V123.717H347.018L344.868 125.275V124.162L347.118 122.545H348.166V131H347.112Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-131-inside-31_3383_10956' fill='var(--white)'>
          <path d='M26 145H59.9V178.9H26V145Z' />
        </mask>
        <g
          clipPath='url(#paint30_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-131-inside-31_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 178.9V179.9H60.9V178.9H59.9ZM26 178.9H25V179.9H26V178.9ZM58.9 145V178.9H60.9V145H58.9ZM59.9 177.9H26V179.9H59.9V177.9ZM27 178.9V145H25V178.9H27Z'
          mask='url(#path-131-inside-31_3383_10956)'
        />
        <path
          d='M42.0117 165V157.717H41.918L39.7676 159.275V158.162L42.0176 156.545H43.0664V165H42.0117Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-134-inside-32_3383_10956' fill='var(--white)'>
          <path d='M59.9 145H93.8V178.9H59.9V145Z' />
        </mask>
        <g
          clipPath='url(#paint31_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-134-inside-32_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 178.9V179.9H94.8V178.9H93.8ZM92.8 145V178.9H94.8V145H92.8ZM93.8 177.9H59.9V179.9H93.8V177.9Z'
          mask='url(#path-134-inside-32_3383_10956)'
        />
        <path
          d='M75.9 157.667V161M75.9 161V164.333M75.9 161H72.5667M75.9 161H79.2334'
          stroke='var(--black)'
          strokeOpacity='0.1'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-137-inside-33_3383_10956' fill='var(--white)'>
          <path d='M93.8 145H127.7V178.9H93.8V145Z' />
        </mask>
        <g
          clipPath='url(#paint32_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-137-inside-33_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 178.9V179.9H128.7V178.9H127.7ZM126.7 145V178.9H128.7V145H126.7ZM127.7 177.9H93.8V179.9H127.7V177.9Z'
          mask='url(#path-137-inside-33_3383_10956)'
        />
        <path d='M106.467 161H113.133' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-140-inside-34_3383_10956' fill='var(--white)'>
          <path d='M127.7 145H161.6V178.9H127.7V145Z' />
        </mask>
        <g
          clipPath='url(#paint33_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-140-inside-34_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 178.9V179.9H162.6V178.9H161.6ZM160.6 145V178.9H162.6V145H160.6ZM161.6 177.9H127.7V179.9H161.6V177.9Z'
          mask='url(#path-140-inside-34_3383_10956)'
        />
        <path
          d='M143.473 165.199C142.848 165.199 142.313 165.02 141.868 164.66C141.427 164.301 141.087 163.791 140.848 163.131C140.61 162.467 140.491 161.682 140.491 160.775V160.764C140.491 159.857 140.61 159.074 140.848 158.414C141.087 157.754 141.427 157.244 141.868 156.885C142.313 156.525 142.848 156.346 143.473 156.346C144.098 156.346 144.634 156.525 145.079 156.885C145.524 157.244 145.866 157.754 146.104 158.414C146.346 159.074 146.468 159.857 146.468 160.764V160.775C146.468 161.682 146.346 162.467 146.104 163.131C145.866 163.791 145.524 164.301 145.079 164.66C144.634 165.02 144.098 165.199 143.473 165.199ZM143.473 164.279C143.88 164.279 144.225 164.137 144.511 163.852C144.8 163.566 145.02 163.162 145.173 162.639C145.329 162.115 145.407 161.494 145.407 160.775V160.764C145.407 160.045 145.329 159.426 145.173 158.906C145.02 158.383 144.8 157.98 144.511 157.699C144.225 157.414 143.88 157.271 143.473 157.271C143.071 157.271 142.725 157.414 142.436 157.699C142.151 157.98 141.932 158.383 141.78 158.906C141.628 159.426 141.552 160.045 141.552 160.764V160.775C141.552 161.494 141.628 162.115 141.78 162.639C141.932 163.162 142.151 163.566 142.436 163.852C142.725 164.137 143.071 164.279 143.473 164.279Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-143-inside-35_3383_10956' fill='var(--white)'>
          <path d='M161.6 145H195.5V178.9H161.6V145Z' />
        </mask>
        <g
          clipPath='url(#paint34_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-143-inside-35_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 178.9V179.9H196.5V178.9H195.5ZM194.5 145V178.9H196.5V145H194.5ZM195.5 177.9H161.6V179.9H195.5V177.9Z'
          mask='url(#path-143-inside-35_3383_10956)'
        />
        <path
          d='M177.612 165V157.717H177.518L175.368 159.275V158.162L177.618 156.545H178.666V165H177.612Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-146-inside-36_3383_10956' fill='var(--white)'>
          <path d='M195.5 145H229.4V178.9H195.5V145Z' />
        </mask>
        <g
          clipPath='url(#paint35_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-146-inside-36_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 178.9V179.9H230.4V178.9H229.4ZM228.4 145V178.9H230.4V145H228.4ZM229.4 177.9H195.5V179.9H229.4V177.9Z'
          mask='url(#path-146-inside-36_3383_10956)'
        />
        <path
          d='M211.5 157.667V161M211.5 161V164.333M211.5 161H208.167M211.5 161H214.833'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-149-inside-37_3383_10956' fill='var(--white)'>
          <path d='M229.4 145H263.3V178.9H229.4V145Z' />
        </mask>
        <g
          clipPath='url(#paint36_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-149-inside-37_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 178.9V179.9H264.3V178.9H263.3ZM262.3 145V178.9H264.3V145H262.3ZM263.3 177.9H229.4V179.9H263.3V177.9Z'
          mask='url(#path-149-inside-37_3383_10956)'
        />
        <path d='M242.067 161H248.733' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-152-inside-38_3383_10956' fill='var(--white)'>
          <path d='M263.3 145H297.2V178.9H263.3V145Z' />
        </mask>
        <g
          clipPath='url(#paint37_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-152-inside-38_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 178.9V179.9H298.2V178.9H297.2ZM296.2 145V178.9H298.2V145H296.2ZM297.2 177.9H263.3V179.9H297.2V177.9Z'
          mask='url(#path-152-inside-38_3383_10956)'
        />
        <path
          d='M279.073 165.199C278.448 165.199 277.913 165.02 277.468 164.66C277.027 164.301 276.687 163.791 276.448 163.131C276.21 162.467 276.091 161.682 276.091 160.775V160.764C276.091 159.857 276.21 159.074 276.448 158.414C276.687 157.754 277.027 157.244 277.468 156.885C277.913 156.525 278.448 156.346 279.073 156.346C279.698 156.346 280.234 156.525 280.679 156.885C281.124 157.244 281.466 157.754 281.704 158.414C281.947 159.074 282.068 159.857 282.068 160.764V160.775C282.068 161.682 281.947 162.467 281.704 163.131C281.466 163.791 281.124 164.301 280.679 164.66C280.234 165.02 279.698 165.199 279.073 165.199ZM279.073 164.279C279.48 164.279 279.825 164.137 280.111 163.852C280.4 163.566 280.62 163.162 280.773 162.639C280.929 162.115 281.007 161.494 281.007 160.775V160.764C281.007 160.045 280.929 159.426 280.773 158.906C280.62 158.383 280.4 157.98 280.111 157.699C279.825 157.414 279.48 157.271 279.073 157.271C278.671 157.271 278.325 157.414 278.036 157.699C277.751 157.98 277.532 158.383 277.38 158.906C277.228 159.426 277.152 160.045 277.152 160.764V160.775C277.152 161.494 277.228 162.115 277.38 162.639C277.532 163.162 277.751 163.566 278.036 163.852C278.325 164.137 278.671 164.279 279.073 164.279Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-155-inside-39_3383_10956' fill='var(--white)'>
          <path d='M297.2 145H331.1V178.9H297.2V145Z' />
        </mask>
        <g
          clipPath='url(#paint38_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-155-inside-39_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 178.9V179.9H332.1V178.9H331.1ZM330.1 145V178.9H332.1V145H330.1ZM331.1 177.9H297.2V179.9H331.1V177.9Z'
          mask='url(#path-155-inside-39_3383_10956)'
        />
        <path
          d='M313.212 165V157.717H313.118L310.968 159.275V158.162L313.218 156.545H314.266V165H313.212Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-158-inside-40_3383_10956' fill='var(--white)'>
          <path d='M331.1 145H365V178.9H331.1V145Z' />
        </mask>
        <g
          clipPath='url(#paint39_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-158-inside-40_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 161.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 178.9V179.9H366V178.9H365ZM364 145V178.9H366V145H364ZM365 177.9H331.1V179.9H365V177.9Z'
          mask='url(#path-158-inside-40_3383_10956)'
        />
        <rect x='343' y='154.492' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.2' />
        <rect x='343' y='164.503' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.2' />
        <rect x='347.996' y='159.497' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.2' />
        <mask id='path-163-inside-41_3383_10956' fill='var(--white)'>
          <path d='M26 179H59.9V212.9H26V179Z' />
        </mask>
        <g
          clipPath='url(#paint40_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-163-inside-41_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 212.9V213.9H60.9V212.9H59.9ZM26 212.9H25V213.9H26V212.9ZM58.9 179V212.9H60.9V179H58.9ZM59.9 211.9H26V213.9H59.9V211.9ZM27 212.9V179H25V212.9H27Z'
          mask='url(#path-163-inside-41_3383_10956)'
        />
        <rect x='38' y='188.492' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='38' y='198.503' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='42.9956' y='193.497' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <mask id='path-168-inside-42_3383_10956' fill='var(--white)'>
          <path d='M59.9 179H93.8V212.9H59.9V179Z' />
        </mask>
        <g
          clipPath='url(#paint41_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-168-inside-42_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 212.9V213.9H94.8V212.9H93.8ZM92.8 179V212.9H94.8V179H92.8ZM93.8 211.9H59.9V213.9H93.8V211.9Z'
          mask='url(#path-168-inside-42_3383_10956)'
        />
        <path
          d='M75.6735 199.199C75.0485 199.199 74.5133 199.02 74.068 198.66C73.6266 198.301 73.2867 197.791 73.0485 197.131C72.8102 196.467 72.691 195.682 72.691 194.775V194.764C72.691 193.857 72.8102 193.074 73.0485 192.414C73.2867 191.754 73.6266 191.244 74.068 190.885C74.5133 190.525 75.0485 190.346 75.6735 190.346C76.2985 190.346 76.8336 190.525 77.2789 190.885C77.7242 191.244 78.066 191.754 78.3043 192.414C78.5465 193.074 78.6676 193.857 78.6676 194.764V194.775C78.6676 195.682 78.5465 196.467 78.3043 197.131C78.066 197.791 77.7242 198.301 77.2789 198.66C76.8336 199.02 76.2985 199.199 75.6735 199.199ZM75.6735 198.279C76.0797 198.279 76.4254 198.137 76.7106 197.852C76.9996 197.566 77.2203 197.162 77.3727 196.639C77.5289 196.115 77.6071 195.494 77.6071 194.775V194.764C77.6071 194.045 77.5289 193.426 77.3727 192.906C77.2203 192.383 76.9996 191.98 76.7106 191.699C76.4254 191.414 76.0797 191.271 75.6735 191.271C75.2711 191.271 74.9254 191.414 74.6364 191.699C74.3512 191.98 74.1324 192.383 73.9801 192.906C73.8278 193.426 73.7516 194.045 73.7516 194.764V194.775C73.7516 195.494 73.8278 196.115 73.9801 196.639C74.1324 197.162 74.3512 197.566 74.6364 197.852C74.9254 198.137 75.2711 198.279 75.6735 198.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-171-inside-43_3383_10956' fill='var(--white)'>
          <path d='M93.8 179H127.7V212.9H93.8V179Z' />
        </mask>
        <g
          clipPath='url(#paint42_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-171-inside-43_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 212.9V213.9H128.7V212.9H127.7ZM126.7 179V212.9H128.7V179H126.7ZM127.7 211.9H93.8V213.9H127.7V211.9Z'
          mask='url(#path-171-inside-43_3383_10956)'
        />
        <path d='M106.467 195H113.133' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-174-inside-44_3383_10956' fill='var(--white)'>
          <path d='M127.7 179H161.6V212.9H127.7V179Z' />
        </mask>
        <g
          clipPath='url(#paint43_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-174-inside-44_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 212.9V213.9H162.6V212.9H161.6ZM160.6 179V212.9H162.6V179H160.6ZM161.6 211.9H127.7V213.9H161.6V211.9Z'
          mask='url(#path-174-inside-44_3383_10956)'
        />
        <path
          d='M143.473 199.199C142.848 199.199 142.313 199.02 141.868 198.66C141.427 198.301 141.087 197.791 140.848 197.131C140.61 196.467 140.491 195.682 140.491 194.775V194.764C140.491 193.857 140.61 193.074 140.848 192.414C141.087 191.754 141.427 191.244 141.868 190.885C142.313 190.525 142.848 190.346 143.473 190.346C144.098 190.346 144.634 190.525 145.079 190.885C145.524 191.244 145.866 191.754 146.104 192.414C146.346 193.074 146.468 193.857 146.468 194.764V194.775C146.468 195.682 146.346 196.467 146.104 197.131C145.866 197.791 145.524 198.301 145.079 198.66C144.634 199.02 144.098 199.199 143.473 199.199ZM143.473 198.279C143.88 198.279 144.225 198.137 144.511 197.852C144.8 197.566 145.02 197.162 145.173 196.639C145.329 196.115 145.407 195.494 145.407 194.775V194.764C145.407 194.045 145.329 193.426 145.173 192.906C145.02 192.383 144.8 191.98 144.511 191.699C144.225 191.414 143.88 191.271 143.473 191.271C143.071 191.271 142.725 191.414 142.436 191.699C142.151 191.98 141.932 192.383 141.78 192.906C141.628 193.426 141.552 194.045 141.552 194.764V194.775C141.552 195.494 141.628 196.115 141.78 196.639C141.932 197.162 142.151 197.566 142.436 197.852C142.725 198.137 143.071 198.279 143.473 198.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-177-inside-45_3383_10956' fill='var(--white)'>
          <path d='M161.6 179H195.5V212.9H161.6V179Z' />
        </mask>
        <g
          clipPath='url(#paint44_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-177-inside-45_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 212.9V213.9H196.5V212.9H195.5ZM161.6 212.9H160.6V213.9H161.6V212.9ZM194.5 179V212.9H196.5V179H194.5ZM195.5 211.9H161.6V213.9H195.5V211.9ZM162.6 212.9V179H160.6V212.9H162.6Z'
          mask='url(#path-177-inside-45_3383_10956)'
        />
        <path
          d='M177.612 199V191.717H177.518L175.368 193.275V192.162L177.618 190.545H178.666V199H177.612Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-180-inside-46_3383_10956' fill='var(--white)'>
          <path d='M195.5 179H229.4V212.9H195.5V179Z' />
        </mask>
        <g
          clipPath='url(#paint45_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-180-inside-46_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 212.9V213.9H230.4V212.9H229.4ZM228.4 179V212.9H230.4V179H228.4ZM229.4 211.9H195.5V213.9H229.4V211.9Z'
          mask='url(#path-180-inside-46_3383_10956)'
        />
        <path
          d='M211.512 199V191.717H211.418L209.268 193.275V192.162L211.518 190.545H212.566V199H211.512Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-183-inside-47_3383_10956' fill='var(--white)'>
          <path d='M229.4 179H263.3V212.9H229.4V179Z' />
        </mask>
        <g
          clipPath='url(#paint46_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-183-inside-47_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 212.9V213.9H264.3V212.9H263.3ZM262.3 179V212.9H264.3V179H262.3ZM263.3 211.9H229.4V213.9H263.3V211.9Z'
          mask='url(#path-183-inside-47_3383_10956)'
        />
        <path
          d='M245.4 191.667V195M245.4 195V198.333M245.4 195H242.067M245.4 195H248.733'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-186-inside-48_3383_10956' fill='var(--white)'>
          <path d='M263.3 179H297.2V212.9H263.3V179Z' />
        </mask>
        <g
          clipPath='url(#paint47_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-186-inside-48_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 212.9V213.9H298.2V212.9H297.2ZM296.2 179V212.9H298.2V179H296.2ZM297.2 211.9H263.3V213.9H297.2V211.9Z'
          mask='url(#path-186-inside-48_3383_10956)'
        />
        <path d='M275.967 195H282.633' stroke='var(--black)' strokeOpacity='0.1' strokeLinecap='square' />
        <mask id='path-189-inside-49_3383_10956' fill='var(--white)'>
          <path d='M297.2 179H331.1V212.9H297.2V179Z' />
        </mask>
        <g
          clipPath='url(#paint48_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-189-inside-49_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 212.9V213.9H332.1V212.9H331.1ZM330.1 179V212.9H332.1V179H330.1ZM331.1 211.9H297.2V213.9H331.1V211.9Z'
          mask='url(#path-189-inside-49_3383_10956)'
        />
        <path
          d='M313.2 191.667V195M313.2 195V198.333M313.2 195H309.867M313.2 195H316.533'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-192-inside-50_3383_10956' fill='var(--white)'>
          <path d='M331.1 179H365V212.9H331.1V179Z' />
        </mask>
        <g
          clipPath='url(#paint49_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-192-inside-50_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 195.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 212.9V213.9H366V212.9H365ZM364 179V212.9H366V179H364ZM365 211.9H331.1V213.9H365V211.9Z'
          mask='url(#path-192-inside-50_3383_10956)'
        />
        <path
          d='M347.112 199V191.717H347.018L344.868 193.275V192.162L347.118 190.545H348.166V199H347.112Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-195-inside-51_3383_10956' fill='var(--white)'>
          <path d='M26 213H59.9V246.9H26V213Z' />
        </mask>
        <g
          clipPath='url(#paint50_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-195-inside-51_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 246.9V247.9H60.9V246.9H59.9ZM58.9 213V246.9H60.9V213H58.9ZM59.9 245.9H26V247.9H59.9V245.9Z'
          mask='url(#path-195-inside-51_3383_10956)'
        />
        <path
          d='M42 225.667V229M42 229V232.333M42 229H38.6667M42 229H45.3334'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-198-inside-52_3383_10956' fill='var(--white)'>
          <path d='M59.9 213H93.8V246.9H59.9V213Z' />
        </mask>
        <g
          clipPath='url(#paint51_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-198-inside-52_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 246.9V247.9H94.8V246.9H93.8ZM92.8 213V246.9H94.8V213H92.8ZM93.8 245.9H59.9V247.9H93.8V245.9Z'
          mask='url(#path-198-inside-52_3383_10956)'
        />
        <path d='M72.5667 229H79.2334' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-201-inside-53_3383_10956' fill='var(--white)'>
          <path d='M93.8 213H127.7V246.9H93.8V213Z' />
        </mask>
        <g
          clipPath='url(#paint52_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-201-inside-53_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 246.9V247.9H128.7V246.9H127.7ZM126.7 213V246.9H128.7V213H126.7ZM127.7 245.9H93.8V247.9H127.7V245.9Z'
          mask='url(#path-201-inside-53_3383_10956)'
        />
        <path
          d='M109.573 233.199C108.948 233.199 108.413 233.02 107.968 232.66C107.527 232.301 107.187 231.791 106.948 231.131C106.71 230.467 106.591 229.682 106.591 228.775V228.764C106.591 227.857 106.71 227.074 106.948 226.414C107.187 225.754 107.527 225.244 107.968 224.885C108.413 224.525 108.948 224.346 109.573 224.346C110.198 224.346 110.734 224.525 111.179 224.885C111.624 225.244 111.966 225.754 112.204 226.414C112.446 227.074 112.568 227.857 112.568 228.764V228.775C112.568 229.682 112.446 230.467 112.204 231.131C111.966 231.791 111.624 232.301 111.179 232.66C110.734 233.02 110.198 233.199 109.573 233.199ZM109.573 232.279C109.98 232.279 110.325 232.137 110.611 231.852C110.9 231.566 111.12 231.162 111.273 230.639C111.429 230.115 111.507 229.494 111.507 228.775V228.764C111.507 228.045 111.429 227.426 111.273 226.906C111.12 226.383 110.9 225.98 110.611 225.699C110.325 225.414 109.98 225.271 109.573 225.271C109.171 225.271 108.825 225.414 108.536 225.699C108.251 225.98 108.032 226.383 107.88 226.906C107.728 227.426 107.652 228.045 107.652 228.764V228.775C107.652 229.494 107.728 230.115 107.88 230.639C108.032 231.162 108.251 231.566 108.536 231.852C108.825 232.137 109.171 232.279 109.573 232.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-204-inside-54_3383_10956' fill='var(--white)'>
          <path d='M127.7 213H161.6V246.9H127.7V213Z' />
        </mask>
        <g
          clipPath='url(#paint53_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-204-inside-54_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 246.9V247.9H162.6V246.9H161.6ZM160.6 213V246.9H162.6V213H160.6ZM161.6 245.9H127.7V247.9H161.6V245.9Z'
          mask='url(#path-204-inside-54_3383_10956)'
        />
        <path
          d='M143.473 233.199C142.848 233.199 142.313 233.02 141.868 232.66C141.427 232.301 141.087 231.791 140.848 231.131C140.61 230.467 140.491 229.682 140.491 228.775V228.764C140.491 227.857 140.61 227.074 140.848 226.414C141.087 225.754 141.427 225.244 141.868 224.885C142.313 224.525 142.848 224.346 143.473 224.346C144.098 224.346 144.634 224.525 145.079 224.885C145.524 225.244 145.866 225.754 146.104 226.414C146.346 227.074 146.468 227.857 146.468 228.764V228.775C146.468 229.682 146.346 230.467 146.104 231.131C145.866 231.791 145.524 232.301 145.079 232.66C144.634 233.02 144.098 233.199 143.473 233.199ZM143.473 232.279C143.88 232.279 144.225 232.137 144.511 231.852C144.8 231.566 145.02 231.162 145.173 230.639C145.329 230.115 145.407 229.494 145.407 228.775V228.764C145.407 228.045 145.329 227.426 145.173 226.906C145.02 226.383 144.8 225.98 144.511 225.699C144.225 225.414 143.88 225.271 143.473 225.271C143.071 225.271 142.725 225.414 142.436 225.699C142.151 225.98 141.932 226.383 141.78 226.906C141.628 227.426 141.552 228.045 141.552 228.764V228.775C141.552 229.494 141.628 230.115 141.78 230.639C141.932 231.162 142.151 231.566 142.436 231.852C142.725 232.137 143.071 232.279 143.473 232.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-207-inside-55_3383_10956' fill='var(--white)'>
          <path d='M161.6 213H195.5V246.9H161.6V213Z' />
        </mask>
        <g
          clipPath='url(#paint54_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-207-inside-55_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 246.9V247.9H196.5V246.9H195.5ZM161.6 246.9H160.6V247.9H161.6V246.9ZM194.5 213V246.9H196.5V213H194.5ZM195.5 245.9H161.6V247.9H195.5V245.9ZM162.6 246.9V213H160.6V246.9H162.6Z'
          mask='url(#path-207-inside-55_3383_10956)'
        />
        <path
          d='M177.612 233V225.717H177.518L175.368 227.275V226.162L177.618 224.545H178.666V233H177.612Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-210-inside-56_3383_10956' fill='var(--white)'>
          <path d='M195.5 213H229.4V246.9H195.5V213Z' />
        </mask>
        <g
          clipPath='url(#paint55_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-210-inside-56_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 246.9V247.9H230.4V246.9H229.4ZM228.4 213V246.9H230.4V213H228.4ZM229.4 245.9H195.5V247.9H229.4V245.9Z'
          mask='url(#path-210-inside-56_3383_10956)'
        />
        <mask
          id='path-212-outside-57_3383_10956'
          maskUnits='userSpaceOnUse'
          x='207.5'
          y='223'
          width='7'
          height='11'
          fill='black'
        >
          <rect fill='var(--white)' x='207.5' y='223' width='7' height='11' />
          <path d='M211.512 233V225.717H211.418L209.268 227.275V226.162L211.518 224.545H212.566V233H211.512Z' />
        </mask>
        <path
          d='M211.512 233V225.717H211.418L209.268 227.275V226.162L211.518 224.545H212.566V233H211.512Z'
          fill='var(--black)'
          fillOpacity='0.1'
        />
        <path
          d='M211.512 233H210.512V234H211.512V233ZM211.512 225.717H212.512V224.717H211.512V225.717ZM211.418 225.717V224.717H211.094L210.831 224.907L211.418 225.717ZM209.268 227.275H208.268V229.235L209.854 228.085L209.268 227.275ZM209.268 226.162L208.684 225.35L208.268 225.649V226.162H209.268ZM211.518 224.545V223.545H211.195L210.934 223.733L211.518 224.545ZM212.566 224.545H213.566V223.545H212.566V224.545ZM212.566 233V234H213.566V233H212.566ZM212.512 233V225.717H210.512V233H212.512ZM211.512 224.717H211.418V226.717H211.512V224.717ZM210.831 224.907L208.681 226.466L209.854 228.085L212.005 226.526L210.831 224.907ZM210.268 227.275V226.162H208.268V227.275H210.268ZM209.851 226.974L212.101 225.357L210.934 223.733L208.684 225.35L209.851 226.974ZM211.518 225.545H212.566V223.545H211.518V225.545ZM211.566 224.545V233H213.566V224.545H211.566ZM212.566 232H211.512V234H212.566V232Z'
          fill='var(--black)'
          fillOpacity='0.1'
          mask='url(#path-212-outside-57_3383_10956)'
        />
        <mask id='path-214-inside-58_3383_10956' fill='var(--white)'>
          <path d='M229.4 213H263.3V246.9H229.4V213Z' />
        </mask>
        <g
          clipPath='url(#paint56_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-214-inside-58_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 246.9V247.9H264.3V246.9H263.3ZM262.3 213V246.9H264.3V213H262.3ZM263.3 245.9H229.4V247.9H263.3V245.9Z'
          mask='url(#path-214-inside-58_3383_10956)'
        />
        <path
          d='M245.4 225.667V229M245.4 229V232.333M245.4 229H242.067M245.4 229H248.733'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-217-inside-59_3383_10956' fill='var(--white)'>
          <path d='M263.3 213H297.2V246.9H263.3V213Z' />
        </mask>
        <g
          clipPath='url(#paint57_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-217-inside-59_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 246.9V247.9H298.2V246.9H297.2ZM296.2 213V246.9H298.2V213H296.2ZM297.2 245.9H263.3V247.9H297.2V245.9Z'
          mask='url(#path-217-inside-59_3383_10956)'
        />
        <path d='M275.967 229H282.633' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-220-inside-60_3383_10956' fill='var(--white)'>
          <path d='M297.2 213H331.1V246.9H297.2V213Z' />
        </mask>
        <g
          clipPath='url(#paint58_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-220-inside-60_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 246.9V247.9H332.1V246.9H331.1ZM330.1 213V246.9H332.1V213H330.1ZM331.1 245.9H297.2V247.9H331.1V245.9Z'
          mask='url(#path-220-inside-60_3383_10956)'
        />
        <rect x='319' y='228.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='314.2' y='228.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='311.8' y='228.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='309.4' y='228.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='307' y='228.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='316.6' y='228.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='316.6' y='226.4' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 316.6 233.6)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <rect x='314.2' y='224' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 319 231.2)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <mask id='path-232-inside-61_3383_10956' fill='var(--white)'>
          <path d='M331.1 213H365V246.9H331.1V213Z' />
        </mask>
        <g
          clipPath='url(#paint59_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-232-inside-61_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 229.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 246.9V247.9H366V246.9H365ZM364 213V246.9H366V213H364ZM365 245.9H331.1V247.9H365V245.9Z'
          mask='url(#path-232-inside-61_3383_10956)'
        />
        <path
          d='M347.112 233V225.717H347.018L344.868 227.275V226.162L347.118 224.545H348.166V233H347.112Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-235-inside-62_3383_10956' fill='var(--white)'>
          <path d='M26 247H59.9V280.9H26V247Z' />
        </mask>
        <g
          clipPath='url(#paint60_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-235-inside-62_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 280.9V281.9H60.9V280.9H59.9ZM58.9 247V280.9H60.9V247H58.9ZM59.9 279.9H26V281.9H59.9V279.9Z'
          mask='url(#path-235-inside-62_3383_10956)'
        />
        <rect x='38' y='256.492' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='38' y='266.503' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='42.9956' y='261.497' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <mask id='path-240-inside-63_3383_10956' fill='var(--white)'>
          <path d='M59.9 247H93.8V280.9H59.9V247Z' />
        </mask>
        <g
          clipPath='url(#paint61_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-240-inside-63_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 280.9V281.9H94.8V280.9H93.8ZM92.8 247V280.9H94.8V247H92.8ZM93.8 279.9H59.9V281.9H93.8V279.9Z'
          mask='url(#path-240-inside-63_3383_10956)'
        />
        <path d='M72.5667 263H79.2334' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-243-inside-64_3383_10956' fill='var(--white)'>
          <path d='M93.8 247H127.7V280.9H93.8V247Z' />
        </mask>
        <g
          clipPath='url(#paint62_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-243-inside-64_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 280.9V281.9H128.7V280.9H127.7ZM126.7 247V280.9H128.7V247H126.7ZM127.7 279.9H93.8V281.9H127.7V279.9Z'
          mask='url(#path-243-inside-64_3383_10956)'
        />
        <path
          d='M109.573 267.199C108.948 267.199 108.413 267.02 107.968 266.66C107.527 266.301 107.187 265.791 106.948 265.131C106.71 264.467 106.591 263.682 106.591 262.775V262.764C106.591 261.857 106.71 261.074 106.948 260.414C107.187 259.754 107.527 259.244 107.968 258.885C108.413 258.525 108.948 258.346 109.573 258.346C110.198 258.346 110.734 258.525 111.179 258.885C111.624 259.244 111.966 259.754 112.204 260.414C112.446 261.074 112.568 261.857 112.568 262.764V262.775C112.568 263.682 112.446 264.467 112.204 265.131C111.966 265.791 111.624 266.301 111.179 266.66C110.734 267.02 110.198 267.199 109.573 267.199ZM109.573 266.279C109.98 266.279 110.325 266.137 110.611 265.852C110.9 265.566 111.12 265.162 111.273 264.639C111.429 264.115 111.507 263.494 111.507 262.775V262.764C111.507 262.045 111.429 261.426 111.273 260.906C111.12 260.383 110.9 259.98 110.611 259.699C110.325 259.414 109.98 259.271 109.573 259.271C109.171 259.271 108.825 259.414 108.536 259.699C108.251 259.98 108.032 260.383 107.88 260.906C107.728 261.426 107.652 262.045 107.652 262.764V262.775C107.652 263.494 107.728 264.115 107.88 264.639C108.032 265.162 108.251 265.566 108.536 265.852C108.825 266.137 109.171 266.279 109.573 266.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-246-inside-65_3383_10956' fill='var(--white)'>
          <path d='M127.7 247H161.6V280.9H127.7V247Z' />
        </mask>
        <g
          clipPath='url(#paint63_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-246-inside-65_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 280.9V281.9H162.6V280.9H161.6ZM160.6 247V280.9H162.6V247H160.6ZM161.6 279.9H127.7V281.9H161.6V279.9Z'
          mask='url(#path-246-inside-65_3383_10956)'
        />
        <path
          d='M143.473 267.199C142.848 267.199 142.313 267.02 141.868 266.66C141.427 266.301 141.087 265.791 140.848 265.131C140.61 264.467 140.491 263.682 140.491 262.775V262.764C140.491 261.857 140.61 261.074 140.848 260.414C141.087 259.754 141.427 259.244 141.868 258.885C142.313 258.525 142.848 258.346 143.473 258.346C144.098 258.346 144.634 258.525 145.079 258.885C145.524 259.244 145.866 259.754 146.104 260.414C146.346 261.074 146.468 261.857 146.468 262.764V262.775C146.468 263.682 146.346 264.467 146.104 265.131C145.866 265.791 145.524 266.301 145.079 266.66C144.634 267.02 144.098 267.199 143.473 267.199ZM143.473 266.279C143.88 266.279 144.225 266.137 144.511 265.852C144.8 265.566 145.02 265.162 145.173 264.639C145.329 264.115 145.407 263.494 145.407 262.775V262.764C145.407 262.045 145.329 261.426 145.173 260.906C145.02 260.383 144.8 259.98 144.511 259.699C144.225 259.414 143.88 259.271 143.473 259.271C143.071 259.271 142.725 259.414 142.436 259.699C142.151 259.98 141.932 260.383 141.78 260.906C141.628 261.426 141.552 262.045 141.552 262.764V262.775C141.552 263.494 141.628 264.115 141.78 264.639C141.932 265.162 142.151 265.566 142.436 265.852C142.725 266.137 143.071 266.279 143.473 266.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-249-inside-66_3383_10956' fill='var(--white)'>
          <path d='M161.6 247H195.5V280.9H161.6V247Z' />
        </mask>
        <g
          clipPath='url(#paint64_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-249-inside-66_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 280.9V281.9H196.5V280.9H195.5ZM161.6 280.9H160.6V281.9H161.6V280.9ZM194.5 247V280.9H196.5V247H194.5ZM195.5 279.9H161.6V281.9H195.5V279.9ZM162.6 280.9V247H160.6V280.9H162.6Z'
          mask='url(#path-249-inside-66_3383_10956)'
        />
        <path
          d='M177.612 267V259.717H177.518L175.368 261.275V260.162L177.618 258.545H178.666V267H177.612Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-252-inside-67_3383_10956' fill='var(--white)'>
          <path d='M195.5 247H229.4V280.9H195.5V247Z' />
        </mask>
        <g
          clipPath='url(#paint65_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-252-inside-67_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 280.9V281.9H230.4V280.9H229.4ZM228.4 247V280.9H230.4V247H228.4ZM229.4 279.9H195.5V281.9H229.4V279.9Z'
          mask='url(#path-252-inside-67_3383_10956)'
        />
        <path
          d='M211.512 267V259.717H211.418L209.268 261.275V260.162L211.518 258.545H212.566V267H211.512Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-255-inside-68_3383_10956' fill='var(--white)'>
          <path d='M229.4 247H263.3V280.9H229.4V247Z' />
        </mask>
        <g
          clipPath='url(#paint66_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-255-inside-68_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 280.9V281.9H264.3V280.9H263.3ZM262.3 247V280.9H264.3V247H262.3ZM263.3 279.9H229.4V281.9H263.3V279.9Z'
          mask='url(#path-255-inside-68_3383_10956)'
        />
        <path
          d='M245.4 259.667V263M245.4 263V266.333M245.4 263H242.067M245.4 263H248.733'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-258-inside-69_3383_10956' fill='var(--white)'>
          <path d='M263.3 247H297.2V280.9H263.3V247Z' />
        </mask>
        <g
          clipPath='url(#paint67_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-258-inside-69_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 280.9V281.9H298.2V280.9H297.2ZM296.2 247V280.9H298.2V247H296.2ZM297.2 279.9H263.3V281.9H297.2V279.9Z'
          mask='url(#path-258-inside-69_3383_10956)'
        />
        <path d='M275.967 263H282.633' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-261-inside-70_3383_10956' fill='var(--white)'>
          <path d='M297.2 247H331.1V280.9H297.2V247Z' />
        </mask>
        <g
          clipPath='url(#paint68_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-261-inside-70_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 280.9V281.9H332.1V280.9H331.1ZM330.1 247V280.9H332.1V247H330.1ZM331.1 279.9H297.2V281.9H331.1V279.9Z'
          mask='url(#path-261-inside-70_3383_10956)'
        />
        <path
          d='M313.2 259.667V263M313.2 263V266.333M313.2 263H309.867M313.2 263H316.533'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-264-inside-71_3383_10956' fill='var(--white)'>
          <path d='M331.1 247H365V280.9H331.1V247Z' />
        </mask>
        <g
          clipPath='url(#paint69_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-264-inside-71_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 263.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 280.9V281.9H366V280.9H365ZM364 247V280.9H366V247H364ZM365 279.9H331.1V281.9H365V279.9Z'
          mask='url(#path-264-inside-71_3383_10956)'
        />
        <path
          d='M347.112 267V259.717H347.018L344.868 261.275V260.162L347.118 258.545H348.166V267H347.112Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-267-inside-72_3383_10956' fill='var(--white)'>
          <path d='M26 281H59.9V314.9H26V281Z' />
        </mask>
        <g
          clipPath='url(#paint70_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-267-inside-72_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 314.9V315.9H60.9V314.9H59.9ZM58.9 281V314.9H60.9V281H58.9ZM59.9 313.9H26V315.9H59.9V313.9Z'
          mask='url(#path-267-inside-72_3383_10956)'
        />
        <path
          d='M42 293.667V297M42 297V300.333M42 297H38.6667M42 297H45.3334'
          stroke='var(--black)'
          strokeOpacity='0.1'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-270-inside-73_3383_10956' fill='var(--white)'>
          <path d='M59.9 281H93.8V314.9H59.9V281Z' />
        </mask>
        <g
          clipPath='url(#paint71_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-270-inside-73_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 314.9V315.9H94.8V314.9H93.8ZM92.8 281V314.9H94.8V281H92.8ZM93.8 313.9H59.9V315.9H93.8V313.9Z'
          mask='url(#path-270-inside-73_3383_10956)'
        />
        <rect x='81.9999' y='296.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='77.2' y='296.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='74.7998' y='296.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='72.4001' y='296.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='70' y='296.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='79.6002' y='296.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='79.6002' y='294.4' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 79.6002 301.6)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <rect x='77.2' y='292' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 81.9999 299.2)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <mask id='path-282-inside-74_3383_10956' fill='var(--white)'>
          <path d='M93.8 281H127.7V314.9H93.8V281Z' />
        </mask>
        <g
          clipPath='url(#paint72_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-282-inside-74_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 314.9V315.9H128.7V314.9H127.7ZM126.7 281V314.9H128.7V281H126.7ZM127.7 313.9H93.8V315.9H127.7V313.9Z'
          mask='url(#path-282-inside-74_3383_10956)'
        />
        <path
          d='M109.573 301.199C108.948 301.199 108.413 301.02 107.968 300.66C107.527 300.301 107.187 299.791 106.948 299.131C106.71 298.467 106.591 297.682 106.591 296.775V296.764C106.591 295.857 106.71 295.074 106.948 294.414C107.187 293.754 107.527 293.244 107.968 292.885C108.413 292.525 108.948 292.346 109.573 292.346C110.198 292.346 110.734 292.525 111.179 292.885C111.624 293.244 111.966 293.754 112.204 294.414C112.446 295.074 112.568 295.857 112.568 296.764V296.775C112.568 297.682 112.446 298.467 112.204 299.131C111.966 299.791 111.624 300.301 111.179 300.66C110.734 301.02 110.198 301.199 109.573 301.199ZM109.573 300.279C109.98 300.279 110.325 300.137 110.611 299.852C110.9 299.566 111.12 299.162 111.273 298.639C111.429 298.115 111.507 297.494 111.507 296.775V296.764C111.507 296.045 111.429 295.426 111.273 294.906C111.12 294.383 110.9 293.98 110.611 293.699C110.325 293.414 109.98 293.271 109.573 293.271C109.171 293.271 108.825 293.414 108.536 293.699C108.251 293.98 108.032 294.383 107.88 294.906C107.728 295.426 107.652 296.045 107.652 296.764V296.775C107.652 297.494 107.728 298.115 107.88 298.639C108.032 299.162 108.251 299.566 108.536 299.852C108.825 300.137 109.171 300.279 109.573 300.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-285-inside-75_3383_10956' fill='var(--white)'>
          <path d='M127.7 281H161.6V314.9H127.7V281Z' />
        </mask>
        <g
          clipPath='url(#paint73_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-285-inside-75_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 314.9V315.9H162.6V314.9H161.6ZM160.6 281V314.9H162.6V281H160.6ZM161.6 313.9H127.7V315.9H161.6V313.9Z'
          mask='url(#path-285-inside-75_3383_10956)'
        />
        <path
          d='M143.712 301V293.717H143.618L141.468 295.275V294.162L143.718 292.545H144.766V301H143.712Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-288-inside-76_3383_10956' fill='var(--white)'>
          <path d='M161.6 281H195.5V314.9H161.6V281Z' />
        </mask>
        <g
          clipPath='url(#paint74_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-288-inside-76_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 314.9V315.9H196.5V314.9H195.5ZM194.5 281V314.9H196.5V281H194.5ZM195.5 313.9H161.6V315.9H195.5V313.9Z'
          mask='url(#path-288-inside-76_3383_10956)'
        />
        <path
          d='M177.373 301.199C176.748 301.199 176.213 301.02 175.768 300.66C175.327 300.301 174.987 299.791 174.748 299.131C174.51 298.467 174.391 297.682 174.391 296.775V296.764C174.391 295.857 174.51 295.074 174.748 294.414C174.987 293.754 175.327 293.244 175.768 292.885C176.213 292.525 176.748 292.346 177.373 292.346C177.998 292.346 178.534 292.525 178.979 292.885C179.424 293.244 179.766 293.754 180.004 294.414C180.246 295.074 180.368 295.857 180.368 296.764V296.775C180.368 297.682 180.246 298.467 180.004 299.131C179.766 299.791 179.424 300.301 178.979 300.66C178.534 301.02 177.998 301.199 177.373 301.199ZM177.373 300.279C177.78 300.279 178.125 300.137 178.411 299.852C178.7 299.566 178.92 299.162 179.073 298.639C179.229 298.115 179.307 297.494 179.307 296.775V296.764C179.307 296.045 179.229 295.426 179.073 294.906C178.92 294.383 178.7 293.98 178.411 293.699C178.125 293.414 177.78 293.271 177.373 293.271C176.971 293.271 176.625 293.414 176.336 293.699C176.051 293.98 175.832 294.383 175.68 294.906C175.528 295.426 175.452 296.045 175.452 296.764V296.775C175.452 297.494 175.528 298.115 175.68 298.639C175.832 299.162 176.051 299.566 176.336 299.852C176.625 300.137 176.971 300.279 177.373 300.279Z'
          fill='var(--black)'
          fillOpacity='0.1'
        />
        <mask id='path-291-inside-77_3383_10956' fill='var(--white)'>
          <path d='M195.5 281H229.4V314.9H195.5V281Z' />
        </mask>
        <g
          clipPath='url(#paint75_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-291-inside-77_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 314.9V315.9H230.4V314.9H229.4ZM195.5 314.9H194.5V315.9H195.5V314.9ZM228.4 281V314.9H230.4V281H228.4ZM229.4 313.9H195.5V315.9H229.4V313.9ZM196.5 314.9V281H194.5V314.9H196.5Z'
          mask='url(#path-291-inside-77_3383_10956)'
        />
        <path
          d='M211.512 301V293.717H211.418L209.268 295.275V294.162L211.518 292.545H212.566V301H211.512Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-294-inside-78_3383_10956' fill='var(--white)'>
          <path d='M229.4 281H263.3V314.9H229.4V281Z' />
        </mask>
        <g
          clipPath='url(#paint76_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-294-inside-78_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 314.9V315.9H264.3V314.9H263.3ZM262.3 281V314.9H264.3V281H262.3ZM263.3 313.9H229.4V315.9H263.3V313.9Z'
          mask='url(#path-294-inside-78_3383_10956)'
        />
        <path
          d='M245.4 293.667V297M245.4 297V300.333M245.4 297H242.067M245.4 297H248.733'
          stroke='var(--black)'
          strokeOpacity='0.1'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-297-inside-79_3383_10956' fill='var(--white)'>
          <path d='M263.3 281H297.2V314.9H263.3V281Z' />
        </mask>
        <g
          clipPath='url(#paint77_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-297-inside-79_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 314.9V315.9H298.2V314.9H297.2ZM296.2 281V314.9H298.2V281H296.2ZM297.2 313.9H263.3V315.9H297.2V313.9Z'
          mask='url(#path-297-inside-79_3383_10956)'
        />
        <path d='M275.967 297H282.633' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-300-inside-80_3383_10956' fill='var(--white)'>
          <path d='M297.2 281H331.1V314.9H297.2V281Z' />
        </mask>
        <g
          clipPath='url(#paint78_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-300-inside-80_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 314.9V315.9H332.1V314.9H331.1ZM330.1 281V314.9H332.1V281H330.1ZM331.1 313.9H297.2V315.9H331.1V313.9Z'
          mask='url(#path-300-inside-80_3383_10956)'
        />
        <path
          d='M313.2 293.667V297M313.2 297V300.333M313.2 297H309.867M313.2 297H316.533'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-303-inside-81_3383_10956' fill='var(--white)'>
          <path d='M331.1 281H365V314.9H331.1V281Z' />
        </mask>
        <g
          clipPath='url(#paint79_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-303-inside-81_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 297.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 314.9V315.9H366V314.9H365ZM364 281V314.9H366V281H364ZM365 313.9H331.1V315.9H365V313.9Z'
          mask='url(#path-303-inside-81_3383_10956)'
        />
        <path
          d='M347.112 301V293.717H347.018L344.868 295.275V294.162L347.118 292.545H348.166V301H347.112Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-306-inside-82_3383_10956' fill='var(--white)'>
          <path d='M26 315H59.9V348.9H26V315Z' />
        </mask>
        <g
          clipPath='url(#paint80_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-306-inside-82_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 348.9V349.9H60.9V348.9H59.9ZM58.9 315V348.9H60.9V315H58.9ZM59.9 347.9H26V349.9H59.9V347.9Z'
          mask='url(#path-306-inside-82_3383_10956)'
        />
        <path d='M38.6667 331H45.3334' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-309-inside-83_3383_10956' fill='var(--white)'>
          <path d='M59.9 315H93.8V348.9H59.9V315Z' />
        </mask>
        <g
          clipPath='url(#paint81_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-309-inside-83_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 348.9V349.9H94.8V348.9H93.8ZM92.8 315V348.9H94.8V315H92.8ZM93.8 347.9H59.9V349.9H93.8V347.9Z'
          mask='url(#path-309-inside-83_3383_10956)'
        />
        <rect x='81.9999' y='330.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='77.2' y='330.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='74.7998' y='330.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='72.4001' y='330.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='70' y='330.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='79.6002' y='330.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='79.6002' y='328.4' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 79.6002 335.6)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <rect x='77.2' y='326' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 81.9999 333.2)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <mask id='path-321-inside-84_3383_10956' fill='var(--white)'>
          <path d='M93.8 315H127.7V348.9H93.8V315Z' />
        </mask>
        <g
          clipPath='url(#paint82_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-321-inside-84_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 348.9V349.9H128.7V348.9H127.7ZM126.7 315V348.9H128.7V315H126.7ZM127.7 347.9H93.8V349.9H127.7V347.9Z'
          mask='url(#path-321-inside-84_3383_10956)'
        />
        <path
          d='M109.8 327.667V331M109.8 331V334.333M109.8 331H106.467M109.8 331H113.133'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-324-inside-85_3383_10956' fill='var(--white)'>
          <path d='M127.7 315H161.6V348.9H127.7V315Z' />
        </mask>
        <g
          clipPath='url(#paint83_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-324-inside-85_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 348.9V349.9H162.6V348.9H161.6ZM160.6 315V348.9H162.6V315H160.6ZM161.6 347.9H127.7V349.9H161.6V347.9Z'
          mask='url(#path-324-inside-85_3383_10956)'
        />
        <path
          d='M143.7 327.667V331M143.7 331V334.333M143.7 331H140.367M143.7 331H147.033'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-327-inside-86_3383_10956' fill='var(--white)'>
          <path d='M161.6 315H195.5V348.9H161.6V315Z' />
        </mask>
        <g
          clipPath='url(#paint84_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-327-inside-86_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 348.9V349.9H196.5V348.9H195.5ZM194.5 315V348.9H196.5V315H194.5ZM195.5 347.9H161.6V349.9H195.5V347.9Z'
          mask='url(#path-327-inside-86_3383_10956)'
        />
        <rect x='174' y='324.492' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='174' y='334.503' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='178.996' y='329.497' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <mask id='path-332-inside-87_3383_10956' fill='var(--white)'>
          <path d='M195.5 315H229.4V348.9H195.5V315Z' />
        </mask>
        <g
          clipPath='url(#paint85_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-332-inside-87_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 348.9V349.9H230.4V348.9H229.4ZM228.4 315V348.9H230.4V315H228.4ZM229.4 347.9H195.5V349.9H229.4V347.9Z'
          mask='url(#path-332-inside-87_3383_10956)'
        />
        <path
          d='M211.512 335V327.717H211.418L209.268 329.275V328.162L211.518 326.545H212.566V335H211.512Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-335-inside-88_3383_10956' fill='var(--white)'>
          <path d='M229.4 315H263.3V348.9H229.4V315Z' />
        </mask>
        <g
          clipPath='url(#paint86_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-335-inside-88_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 348.9V349.9H264.3V348.9H263.3ZM262.3 315V348.9H264.3V315H262.3ZM263.3 347.9H229.4V349.9H263.3V347.9Z'
          mask='url(#path-335-inside-88_3383_10956)'
        />
        <path d='M242.067 331H248.733' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-338-inside-89_3383_10956' fill='var(--white)'>
          <path d='M263.3 315H297.2V348.9H263.3V315Z' />
        </mask>
        <g
          clipPath='url(#paint87_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-338-inside-89_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 348.9V349.9H298.2V348.9H297.2ZM296.2 315V348.9H298.2V315H296.2ZM297.2 347.9H263.3V349.9H297.2V347.9Z'
          mask='url(#path-338-inside-89_3383_10956)'
        />
        <path
          d='M279.073 335.199C278.448 335.199 277.913 335.02 277.468 334.66C277.027 334.301 276.687 333.791 276.448 333.131C276.21 332.467 276.091 331.682 276.091 330.775V330.764C276.091 329.857 276.21 329.074 276.448 328.414C276.687 327.754 277.027 327.244 277.468 326.885C277.913 326.525 278.448 326.346 279.073 326.346C279.698 326.346 280.234 326.525 280.679 326.885C281.124 327.244 281.466 327.754 281.704 328.414C281.947 329.074 282.068 329.857 282.068 330.764V330.775C282.068 331.682 281.947 332.467 281.704 333.131C281.466 333.791 281.124 334.301 280.679 334.66C280.234 335.02 279.698 335.199 279.073 335.199ZM279.073 334.279C279.48 334.279 279.825 334.137 280.111 333.852C280.4 333.566 280.62 333.162 280.773 332.639C280.929 332.115 281.007 331.494 281.007 330.775V330.764C281.007 330.045 280.929 329.426 280.773 328.906C280.62 328.383 280.4 327.98 280.111 327.699C279.825 327.414 279.48 327.271 279.073 327.271C278.671 327.271 278.325 327.414 278.036 327.699C277.751 327.98 277.532 328.383 277.38 328.906C277.228 329.426 277.152 330.045 277.152 330.764V330.775C277.152 331.494 277.228 332.115 277.38 332.639C277.532 333.162 277.751 333.566 278.036 333.852C278.325 334.137 278.671 334.279 279.073 334.279Z'
          fill='var(--black)'
          fillOpacity='0.1'
        />
        <mask id='path-341-inside-90_3383_10956' fill='var(--white)'>
          <path d='M297.2 315H331.1V348.9H297.2V315Z' />
        </mask>
        <g
          clipPath='url(#paint88_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-341-inside-90_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 348.9V349.9H332.1V348.9H331.1ZM330.1 315V348.9H332.1V315H330.1ZM331.1 347.9H297.2V349.9H331.1V347.9Z'
          mask='url(#path-341-inside-90_3383_10956)'
        />
        <path
          d='M313.212 335V327.717H313.118L310.968 329.275V328.162L313.218 326.545H314.266V335H313.212Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-344-inside-91_3383_10956' fill='var(--white)'>
          <path d='M331.1 315H365V348.9H331.1V315Z' />
        </mask>
        <g
          clipPath='url(#paint89_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-344-inside-91_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 331.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 348.9V349.9H366V348.9H365ZM364 315V348.9H366V315H364ZM365 347.9H331.1V349.9H365V347.9Z'
          mask='url(#path-344-inside-91_3383_10956)'
        />
        <path
          d='M347.1 327.667V331M347.1 331V334.333M347.1 331H343.767M347.1 331H350.433'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-347-inside-92_3383_10956' fill='var(--white)'>
          <path d='M26 349H59.9V382.9H26V349Z' />
        </mask>
        <g
          clipPath='url(#paint90_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-347-inside-92_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 382.9V383.9H60.9V382.9H59.9ZM26 382.9H25V383.9H26V382.9ZM58.9 349V382.9H60.9V349H58.9ZM59.9 381.9H26V383.9H59.9V381.9ZM27 382.9V349H25V382.9H27Z'
          mask='url(#path-347-inside-92_3383_10956)'
        />
        <path
          d='M42.0117 369V361.717H41.918L39.7676 363.275V362.162L42.0176 360.545H43.0664V369H42.0117Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-350-inside-93_3383_10956' fill='var(--white)'>
          <path d='M59.9 349H93.8V382.9H59.9V349Z' />
        </mask>
        <g
          clipPath='url(#paint91_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-350-inside-93_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 382.9V383.9H94.8V382.9H93.8ZM92.8 349V382.9H94.8V349H92.8ZM93.8 381.9H59.9V383.9H93.8V381.9Z'
          mask='url(#path-350-inside-93_3383_10956)'
        />
        <path
          d='M75.9 361.667V365M75.9 365V368.333M75.9 365H72.5667M75.9 365H79.2334'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-353-inside-94_3383_10956' fill='var(--white)'>
          <path d='M93.8 349H127.7V382.9H93.8V349Z' />
        </mask>
        <g
          clipPath='url(#paint92_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-353-inside-94_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 382.9V383.9H128.7V382.9H127.7ZM126.7 349V382.9H128.7V349H126.7ZM127.7 381.9H93.8V383.9H127.7V381.9Z'
          mask='url(#path-353-inside-94_3383_10956)'
        />
        <path d='M106.467 365H113.133' stroke='var(--black)' strokeOpacity='0.1' strokeLinecap='square' />
        <mask id='path-356-inside-95_3383_10956' fill='var(--white)'>
          <path d='M127.7 349H161.6V382.9H127.7V349Z' />
        </mask>
        <g
          clipPath='url(#paint93_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-356-inside-95_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 382.9V383.9H162.6V382.9H161.6ZM160.6 349V382.9H162.6V349H160.6ZM161.6 381.9H127.7V383.9H161.6V381.9Z'
          mask='url(#path-356-inside-95_3383_10956)'
        />
        <path
          d='M143.7 361.667V365M143.7 365V368.333M143.7 365H140.367M143.7 365H147.033'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-359-inside-96_3383_10956' fill='var(--white)'>
          <path d='M161.6 349H195.5V382.9H161.6V349Z' />
        </mask>
        <g
          clipPath='url(#paint94_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-359-inside-96_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 382.9V383.9H196.5V382.9H195.5ZM194.5 349V382.9H196.5V349H194.5ZM195.5 381.9H161.6V383.9H195.5V381.9Z'
          mask='url(#path-359-inside-96_3383_10956)'
        />
        <rect x='174' y='358.492' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='174' y='368.503' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <rect x='178.996' y='363.497' width='5.00447' height='5.00447' fill='var(--black)' fillOpacity='0.05' />
        <mask id='path-364-inside-97_3383_10956' fill='var(--white)'>
          <path d='M195.5 349H229.4V382.9H195.5V349Z' />
        </mask>
        <g
          clipPath='url(#paint95_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-364-inside-97_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 382.9V383.9H230.4V382.9H229.4ZM228.4 349V382.9H230.4V349H228.4ZM229.4 381.9H195.5V383.9H229.4V381.9Z'
          mask='url(#path-364-inside-97_3383_10956)'
        />
        <path
          d='M211.512 369V361.717H211.418L209.268 363.275V362.162L211.518 360.545H212.566V369H211.512Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-367-inside-98_3383_10956' fill='var(--white)'>
          <path d='M229.4 349H263.3V382.9H229.4V349Z' />
        </mask>
        <g
          clipPath='url(#paint96_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-367-inside-98_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 382.9V383.9H264.3V382.9H263.3ZM262.3 349V382.9H264.3V349H262.3ZM263.3 381.9H229.4V383.9H263.3V381.9Z'
          mask='url(#path-367-inside-98_3383_10956)'
        />
        <path d='M242.067 365H248.733' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-370-inside-99_3383_10956' fill='var(--white)'>
          <path d='M263.3 349H297.2V382.9H263.3V349Z' />
        </mask>
        <g
          clipPath='url(#paint97_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-370-inside-99_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 382.9V383.9H298.2V382.9H297.2ZM296.2 349V382.9H298.2V349H296.2ZM297.2 381.9H263.3V383.9H297.2V381.9Z'
          mask='url(#path-370-inside-99_3383_10956)'
        />
        <path
          d='M279.073 369.199C278.448 369.199 277.913 369.02 277.468 368.66C277.027 368.301 276.687 367.791 276.448 367.131C276.21 366.467 276.091 365.682 276.091 364.775V364.764C276.091 363.857 276.21 363.074 276.448 362.414C276.687 361.754 277.027 361.244 277.468 360.885C277.913 360.525 278.448 360.346 279.073 360.346C279.698 360.346 280.234 360.525 280.679 360.885C281.124 361.244 281.466 361.754 281.704 362.414C281.947 363.074 282.068 363.857 282.068 364.764V364.775C282.068 365.682 281.947 366.467 281.704 367.131C281.466 367.791 281.124 368.301 280.679 368.66C280.234 369.02 279.698 369.199 279.073 369.199ZM279.073 368.279C279.48 368.279 279.825 368.137 280.111 367.852C280.4 367.566 280.62 367.162 280.773 366.639C280.929 366.115 281.007 365.494 281.007 364.775V364.764C281.007 364.045 280.929 363.426 280.773 362.906C280.62 362.383 280.4 361.98 280.111 361.699C279.825 361.414 279.48 361.271 279.073 361.271C278.671 361.271 278.325 361.414 278.036 361.699C277.751 361.98 277.532 362.383 277.38 362.906C277.228 363.426 277.152 364.045 277.152 364.764V364.775C277.152 365.494 277.228 366.115 277.38 366.639C277.532 367.162 277.751 367.566 278.036 367.852C278.325 368.137 278.671 368.279 279.073 368.279Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-373-inside-100_3383_10956' fill='var(--white)'>
          <path d='M297.2 349H331.1V382.9H297.2V349Z' />
        </mask>
        <g
          clipPath='url(#paint98_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-373-inside-100_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 382.9V383.9H332.1V382.9H331.1ZM330.1 349V382.9H332.1V349H330.1ZM331.1 381.9H297.2V383.9H331.1V381.9Z'
          mask='url(#path-373-inside-100_3383_10956)'
        />
        <mask
          id='path-375-outside-101_3383_10956'
          maskUnits='userSpaceOnUse'
          x='309.2'
          y='359'
          width='7'
          height='11'
          fill='black'
        >
          <rect fill='var(--white)' x='309.2' y='359' width='7' height='11' />
          <path d='M313.212 369V361.717H313.118L310.968 363.275V362.162L313.218 360.545H314.266V369H313.212Z' />
        </mask>
        <path
          d='M313.212 369V361.717H313.118L310.968 363.275V362.162L313.218 360.545H314.266V369H313.212Z'
          fill='var(--black)'
          fillOpacity='0.1'
        />
        <path
          d='M313.212 369H312.212V370H313.212V369ZM313.212 361.717H314.212V360.717H313.212V361.717ZM313.118 361.717V360.717H312.794L312.531 360.907L313.118 361.717ZM310.968 363.275H309.968V365.235L311.554 364.085L310.968 363.275ZM310.968 362.162L310.384 361.35L309.968 361.649V362.162H310.968ZM313.218 360.545V359.545H312.895L312.634 359.733L313.218 360.545ZM314.266 360.545H315.266V359.545H314.266V360.545ZM314.266 369V370H315.266V369H314.266ZM314.212 369V361.717H312.212V369H314.212ZM313.212 360.717H313.118V362.717H313.212V360.717ZM312.531 360.907L310.381 362.466L311.554 364.085L313.705 362.526L312.531 360.907ZM311.968 363.275V362.162H309.968V363.275H311.968ZM311.551 362.974L313.801 361.357L312.634 359.733L310.384 361.35L311.551 362.974ZM313.218 361.545H314.266V359.545H313.218V361.545ZM313.266 360.545V369H315.266V360.545H313.266ZM314.266 368H313.212V370H314.266V368Z'
          fill='var(--black)'
          fillOpacity='0.1'
          mask='url(#path-375-outside-101_3383_10956)'
        />
        <mask id='path-377-inside-102_3383_10956' fill='var(--white)'>
          <path d='M331.1 349H365V382.9H331.1V349Z' />
        </mask>
        <g
          clipPath='url(#paint99_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-377-inside-102_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 365.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 382.9V383.9H366V382.9H365ZM364 349V382.9H366V349H364ZM365 381.9H331.1V383.9H365V381.9Z'
          mask='url(#path-377-inside-102_3383_10956)'
        />
        <path
          d='M347.1 361.667V365M347.1 365V368.333M347.1 365H343.767M347.1 365H350.433'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-380-inside-103_3383_10956' fill='var(--white)'>
          <path d='M26 383H59.9V416.9H26V383Z' />
        </mask>
        <g
          clipPath='url(#paint100_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-380-inside-103_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 416.9V417.9H60.9V416.9H59.9ZM26 416.9H25V417.9H26V416.9ZM58.9 383V416.9H60.9V383H58.9ZM59.9 415.9H26V417.9H59.9V415.9ZM27 416.9V383H25V416.9H27Z'
          mask='url(#path-380-inside-103_3383_10956)'
        />
        <path
          d='M42.0117 403V395.717H41.918L39.7676 397.275V396.162L42.0176 394.545H43.0664V403H42.0117Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-383-inside-104_3383_10956' fill='var(--white)'>
          <path d='M59.9 383H93.8V416.9H59.9V383Z' />
        </mask>
        <g
          clipPath='url(#paint101_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-383-inside-104_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 416.9V417.9H94.8V416.9H93.8ZM92.8 383V416.9H94.8V383H92.8ZM93.8 415.9H59.9V417.9H93.8V415.9Z'
          mask='url(#path-383-inside-104_3383_10956)'
        />
        <path
          d='M75.9 395.667V399M75.9 399V402.333M75.9 399H72.5667M75.9 399H79.2334'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-386-inside-105_3383_10956' fill='var(--white)'>
          <path d='M93.8 383H127.7V416.9H93.8V383Z' />
        </mask>
        <g
          clipPath='url(#paint102_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-386-inside-105_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 416.9V417.9H128.7V416.9H127.7ZM126.7 383V416.9H128.7V383H126.7ZM127.7 415.9H93.8V417.9H127.7V415.9Z'
          mask='url(#path-386-inside-105_3383_10956)'
        />
        <path d='M106.467 399H113.133' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-389-inside-106_3383_10956' fill='var(--white)'>
          <path d='M127.7 383H161.6V416.9H127.7V383Z' />
        </mask>
        <g
          clipPath='url(#paint103_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-389-inside-106_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 416.9V417.9H162.6V416.9H161.6ZM160.6 383V416.9H162.6V383H160.6ZM161.6 415.9H127.7V417.9H161.6V415.9Z'
          mask='url(#path-389-inside-106_3383_10956)'
        />
        <path
          d='M143.473 403.199C142.848 403.199 142.313 403.02 141.868 402.66C141.427 402.301 141.087 401.791 140.848 401.131C140.61 400.467 140.491 399.682 140.491 398.775V398.764C140.491 397.857 140.61 397.074 140.848 396.414C141.087 395.754 141.427 395.244 141.868 394.885C142.313 394.525 142.848 394.346 143.473 394.346C144.098 394.346 144.634 394.525 145.079 394.885C145.524 395.244 145.866 395.754 146.104 396.414C146.346 397.074 146.468 397.857 146.468 398.764V398.775C146.468 399.682 146.346 400.467 146.104 401.131C145.866 401.791 145.524 402.301 145.079 402.66C144.634 403.02 144.098 403.199 143.473 403.199ZM143.473 402.279C143.88 402.279 144.225 402.137 144.511 401.852C144.8 401.566 145.02 401.162 145.173 400.639C145.329 400.115 145.407 399.494 145.407 398.775V398.764C145.407 398.045 145.329 397.426 145.173 396.906C145.02 396.383 144.8 395.98 144.511 395.699C144.225 395.414 143.88 395.271 143.473 395.271C143.071 395.271 142.725 395.414 142.436 395.699C142.151 395.98 141.932 396.383 141.78 396.906C141.628 397.426 141.552 398.045 141.552 398.764V398.775C141.552 399.494 141.628 400.115 141.78 400.639C141.932 401.162 142.151 401.566 142.436 401.852C142.725 402.137 143.071 402.279 143.473 402.279Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-392-inside-107_3383_10956' fill='var(--white)'>
          <path d='M161.6 383H195.5V416.9H161.6V383Z' />
        </mask>
        <g
          clipPath='url(#paint104_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-392-inside-107_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 416.9V417.9H196.5V416.9H195.5ZM194.5 383V416.9H196.5V383H194.5ZM195.5 415.9H161.6V417.9H195.5V415.9Z'
          mask='url(#path-392-inside-107_3383_10956)'
        />
        <rect x='183' y='398.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='178.2' y='398.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='175.8' y='398.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='173.4' y='398.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='171' y='398.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='180.6' y='398.8' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect x='180.6' y='396.4' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 180.6 403.6)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <rect x='178.2' y='394' width='2.40001' height='2.40002' fill='var(--black)' fillOpacity='0.15' />
        <rect
          width='2.40001'
          height='2.40002'
          transform='matrix(-1 0 0 1 183 401.2)'
          fill='var(--black)'
          fillOpacity='0.15'
        />
        <mask id='path-404-inside-108_3383_10956' fill='var(--white)'>
          <path d='M195.5 383H229.4V416.9H195.5V383Z' />
        </mask>
        <g
          clipPath='url(#paint105_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-404-inside-108_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 416.9V417.9H230.4V416.9H229.4ZM228.4 383V416.9H230.4V383H228.4ZM229.4 415.9H195.5V417.9H229.4V415.9Z'
          mask='url(#path-404-inside-108_3383_10956)'
        />
        <path
          d='M211.512 403V395.717H211.418L209.268 397.275V396.162L211.518 394.545H212.566V403H211.512Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-407-inside-109_3383_10956' fill='var(--white)'>
          <path d='M229.4 383H263.3V416.9H229.4V383Z' />
        </mask>
        <g
          clipPath='url(#paint106_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-407-inside-109_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 416.9V417.9H264.3V416.9H263.3ZM262.3 383V416.9H264.3V383H262.3ZM263.3 415.9H229.4V417.9H263.3V415.9Z'
          mask='url(#path-407-inside-109_3383_10956)'
        />
        <path d='M242.067 399H248.733' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-410-inside-110_3383_10956' fill='var(--white)'>
          <path d='M263.3 383H297.2V416.9H263.3V383Z' />
        </mask>
        <g
          clipPath='url(#paint107_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-410-inside-110_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 416.9V417.9H298.2V416.9H297.2ZM296.2 383V416.9H298.2V383H296.2ZM297.2 415.9H263.3V417.9H297.2V415.9Z'
          mask='url(#path-410-inside-110_3383_10956)'
        />
        <path
          d='M279.073 403.199C278.448 403.199 277.913 403.02 277.468 402.66C277.027 402.301 276.687 401.791 276.448 401.131C276.21 400.467 276.091 399.682 276.091 398.775V398.764C276.091 397.857 276.21 397.074 276.448 396.414C276.687 395.754 277.027 395.244 277.468 394.885C277.913 394.525 278.448 394.346 279.073 394.346C279.698 394.346 280.234 394.525 280.679 394.885C281.124 395.244 281.466 395.754 281.704 396.414C281.947 397.074 282.068 397.857 282.068 398.764V398.775C282.068 399.682 281.947 400.467 281.704 401.131C281.466 401.791 281.124 402.301 280.679 402.66C280.234 403.02 279.698 403.199 279.073 403.199ZM279.073 402.279C279.48 402.279 279.825 402.137 280.111 401.852C280.4 401.566 280.62 401.162 280.773 400.639C280.929 400.115 281.007 399.494 281.007 398.775V398.764C281.007 398.045 280.929 397.426 280.773 396.906C280.62 396.383 280.4 395.98 280.111 395.699C279.825 395.414 279.48 395.271 279.073 395.271C278.671 395.271 278.325 395.414 278.036 395.699C277.751 395.98 277.532 396.383 277.38 396.906C277.228 397.426 277.152 398.045 277.152 398.764V398.775C277.152 399.494 277.228 400.115 277.38 400.639C277.532 401.162 277.751 401.566 278.036 401.852C278.325 402.137 278.671 402.279 279.073 402.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-413-inside-111_3383_10956' fill='var(--white)'>
          <path d='M297.2 383H331.1V416.9H297.2V383Z' />
        </mask>
        <g
          clipPath='url(#paint108_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-413-inside-111_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 416.9V417.9H332.1V416.9H331.1ZM330.1 383V416.9H332.1V383H330.1ZM331.1 415.9H297.2V417.9H331.1V415.9Z'
          mask='url(#path-413-inside-111_3383_10956)'
        />
        <path
          d='M313.212 403V395.717H313.118L310.968 397.275V396.162L313.218 394.545H314.266V403H313.212Z'
          fill='var(--black)'
          fillOpacity='0.05'
        />
        <mask id='path-416-inside-112_3383_10956' fill='var(--white)'>
          <path d='M331.1 383H365V416.9H331.1V383Z' />
        </mask>
        <g
          clipPath='url(#paint109_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-416-inside-112_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 399.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 416.9V417.9H366V416.9H365ZM364 383V416.9H366V383H364ZM365 415.9H331.1V417.9H365V415.9Z'
          mask='url(#path-416-inside-112_3383_10956)'
        />
        <path
          d='M347.1 395.667V399M347.1 399V402.333M347.1 399H343.767M347.1 399H350.433'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-419-inside-113_3383_10956' fill='var(--white)'>
          <path d='M26 417H59.9V450.9H26V417Z' />
        </mask>
        <g
          clipPath='url(#paint110_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-419-inside-113_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 42.95 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M59.9 450.9V451.9H60.9V450.9H59.9ZM26 450.9H25V451.9H26V450.9ZM58.9 417V450.9H60.9V417H58.9ZM59.9 449.9H26V451.9H59.9V449.9ZM27 450.9V417H25V450.9H27Z'
          mask='url(#path-419-inside-113_3383_10956)'
        />
        <path
          d='M42.0117 437V429.717H41.918L39.7676 431.275V430.162L42.0176 428.545H43.0664V437H42.0117Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-422-inside-114_3383_10956' fill='var(--white)'>
          <path d='M59.9 417H93.8V450.9H59.9V417Z' />
        </mask>
        <g
          clipPath='url(#paint111_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-422-inside-114_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 76.85 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M93.8 450.9V451.9H94.8V450.9H93.8ZM92.8 417V450.9H94.8V417H92.8ZM93.8 449.9H59.9V451.9H93.8V449.9Z'
          mask='url(#path-422-inside-114_3383_10956)'
        />
        <path
          d='M75.9 429.667V433M75.9 433V436.333M75.9 433H72.5667M75.9 433H79.2334'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-425-inside-115_3383_10956' fill='var(--white)'>
          <path d='M93.8 417H127.7V450.9H93.8V417Z' />
        </mask>
        <g
          clipPath='url(#paint112_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-425-inside-115_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 110.75 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M127.7 450.9V451.9H128.7V450.9H127.7ZM126.7 417V450.9H128.7V417H126.7ZM127.7 449.9H93.8V451.9H127.7V449.9Z'
          mask='url(#path-425-inside-115_3383_10956)'
        />
        <path d='M106.467 433H113.133' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-428-inside-116_3383_10956' fill='var(--white)'>
          <path d='M127.7 417H161.6V450.9H127.7V417Z' />
        </mask>
        <g
          clipPath='url(#paint113_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-428-inside-116_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 144.65 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M161.6 450.9V451.9H162.6V450.9H161.6ZM160.6 417V450.9H162.6V417H160.6ZM161.6 449.9H127.7V451.9H161.6V449.9Z'
          mask='url(#path-428-inside-116_3383_10956)'
        />
        <path
          d='M143.473 437.199C142.848 437.199 142.313 437.02 141.868 436.66C141.427 436.301 141.087 435.791 140.848 435.131C140.61 434.467 140.491 433.682 140.491 432.775V432.764C140.491 431.857 140.61 431.074 140.848 430.414C141.087 429.754 141.427 429.244 141.868 428.885C142.313 428.525 142.848 428.346 143.473 428.346C144.098 428.346 144.634 428.525 145.079 428.885C145.524 429.244 145.866 429.754 146.104 430.414C146.346 431.074 146.468 431.857 146.468 432.764V432.775C146.468 433.682 146.346 434.467 146.104 435.131C145.866 435.791 145.524 436.301 145.079 436.66C144.634 437.02 144.098 437.199 143.473 437.199ZM143.473 436.279C143.88 436.279 144.225 436.137 144.511 435.852C144.8 435.566 145.02 435.162 145.173 434.639C145.329 434.115 145.407 433.494 145.407 432.775V432.764C145.407 432.045 145.329 431.426 145.173 430.906C145.02 430.383 144.8 429.98 144.511 429.699C144.225 429.414 143.88 429.271 143.473 429.271C143.071 429.271 142.725 429.414 142.436 429.699C142.151 429.98 141.932 430.383 141.78 430.906C141.628 431.426 141.552 432.045 141.552 432.764V432.775C141.552 433.494 141.628 434.115 141.78 434.639C141.932 435.162 142.151 435.566 142.436 435.852C142.725 436.137 143.071 436.279 143.473 436.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-431-inside-117_3383_10956' fill='var(--white)'>
          <path d='M161.6 417H195.5V450.9H161.6V417Z' />
        </mask>
        <g
          clipPath='url(#paint114_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-431-inside-117_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 178.55 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M195.5 450.9V451.9H196.5V450.9H195.5ZM194.5 417V450.9H196.5V417H194.5ZM195.5 449.9H161.6V451.9H195.5V449.9Z'
          mask='url(#path-431-inside-117_3383_10956)'
        />
        <path
          d='M177.612 437V429.717H177.518L175.368 431.275V430.162L177.618 428.545H178.666V437H177.612Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-434-inside-118_3383_10956' fill='var(--white)'>
          <path d='M195.5 417H229.4V450.9H195.5V417Z' />
        </mask>
        <g
          clipPath='url(#paint115_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-434-inside-118_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 212.45 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M229.4 450.9V451.9H230.4V450.9H229.4ZM228.4 417V450.9H230.4V417H228.4ZM229.4 449.9H195.5V451.9H229.4V449.9Z'
          mask='url(#path-434-inside-118_3383_10956)'
        />
        <path
          d='M211.5 429.667V433M211.5 433V436.333M211.5 433H208.167M211.5 433H214.833'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
        <mask id='path-437-inside-119_3383_10956' fill='var(--white)'>
          <path d='M229.4 417H263.3V450.9H229.4V417Z' />
        </mask>
        <g
          clipPath='url(#paint116_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-437-inside-119_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 246.35 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M263.3 450.9V451.9H264.3V450.9H263.3ZM262.3 417V450.9H264.3V417H262.3ZM263.3 449.9H229.4V451.9H263.3V449.9Z'
          mask='url(#path-437-inside-119_3383_10956)'
        />
        <path d='M242.067 433H248.733' stroke='var(--black)' strokeOpacity='0.2' strokeLinecap='square' />
        <mask id='path-440-inside-120_3383_10956' fill='var(--white)'>
          <path d='M263.3 417H297.2V450.9H263.3V417Z' />
        </mask>
        <g
          clipPath='url(#paint117_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-440-inside-120_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 280.25 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M297.2 450.9V451.9H298.2V450.9H297.2ZM296.2 417V450.9H298.2V417H296.2ZM297.2 449.9H263.3V451.9H297.2V449.9Z'
          mask='url(#path-440-inside-120_3383_10956)'
        />
        <path
          d='M279.073 437.199C278.448 437.199 277.913 437.02 277.468 436.66C277.027 436.301 276.687 435.791 276.448 435.131C276.21 434.467 276.091 433.682 276.091 432.775V432.764C276.091 431.857 276.21 431.074 276.448 430.414C276.687 429.754 277.027 429.244 277.468 428.885C277.913 428.525 278.448 428.346 279.073 428.346C279.698 428.346 280.234 428.525 280.679 428.885C281.124 429.244 281.466 429.754 281.704 430.414C281.947 431.074 282.068 431.857 282.068 432.764V432.775C282.068 433.682 281.947 434.467 281.704 435.131C281.466 435.791 281.124 436.301 280.679 436.66C280.234 437.02 279.698 437.199 279.073 437.199ZM279.073 436.279C279.48 436.279 279.825 436.137 280.111 435.852C280.4 435.566 280.62 435.162 280.773 434.639C280.929 434.115 281.007 433.494 281.007 432.775V432.764C281.007 432.045 280.929 431.426 280.773 430.906C280.62 430.383 280.4 429.98 280.111 429.699C279.825 429.414 279.48 429.271 279.073 429.271C278.671 429.271 278.325 429.414 278.036 429.699C277.751 429.98 277.532 430.383 277.38 430.906C277.228 431.426 277.152 432.045 277.152 432.764V432.775C277.152 433.494 277.228 434.115 277.38 434.639C277.532 435.162 277.751 435.566 278.036 435.852C278.325 436.137 278.671 436.279 279.073 436.279Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-443-inside-121_3383_10956' fill='var(--white)'>
          <path d='M297.2 417H331.1V450.9H297.2V417Z' />
        </mask>
        <g
          clipPath='url(#paint118_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-443-inside-121_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 314.15 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M331.1 450.9V451.9H332.1V450.9H331.1ZM330.1 417V450.9H332.1V417H330.1ZM331.1 449.9H297.2V451.9H331.1V449.9Z'
          mask='url(#path-443-inside-121_3383_10956)'
        />
        <path
          d='M313.212 437V429.717H313.118L310.968 431.275V430.162L313.218 428.545H314.266V437H313.212Z'
          fill='var(--black)'
          fillOpacity='0.2'
        />
        <mask id='path-446-inside-122_3383_10956' fill='var(--white)'>
          <path d='M331.1 417H365V450.9H331.1V417Z' />
        </mask>
        <g
          clipPath='url(#paint119_angular_3383_10956_clip_path)'
          data-figma-skip-parse='true'
          mask='url(#path-446-inside-122_3383_10956)'
        >
          <g transform='matrix(0 0.01695 -0.01695 0 348.05 433.95)'>
            <foreignObject x='-1059' y='-1059' width='2117.99' height='2117.99'>
              <div
                style={{
                  background:
                    'conic-gradient(from 90deg,var(--dark15) 0deg,var(--dark05) 119.787deg,var(--dark05) 238.271deg,var(--dark15) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: '1',
                }}
              />
            </foreignObject>
          </g>
        </g>
        <path
          d='M365 450.9V451.9H366V450.9H365ZM364 417V450.9H366V417H364ZM365 449.9H331.1V451.9H365V449.9Z'
          mask='url(#path-446-inside-122_3383_10956)'
        />
        <path
          d='M347.1 429.667V433M347.1 433V436.333M347.1 433H343.767M347.1 433H350.433'
          stroke='var(--black)'
          strokeOpacity='0.2'
          strokeWidth='1.5'
          strokeLinecap='square'
        />
      </g>
      <rect
        opacity='0.5'
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 123.321 89.6899)'
        fill='var(--purple)'
      />
      <foreignObject x='48.2885' y='62.2499' width='28.8662' height='28.8664'>
        <div
          style={{
            backdropFilter: 'blur(1.04px);clipPath:url(#bgblur_0_3383_10956_clip_path',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <rect
        data-figma-bg-blur-radius='2.07677'
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 75.0779 64.6533)'
        fill='var(--purple)'
        fillOpacity='0.5'
      />
      <foreignObject x='47.6351' y='111.022' width='28.8662' height='28.8664'>
        <div
          style={{
            backdropFilter: 'blur(1.04px);clipPath:url(#bgblur_1_3383_10956_clip_path',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <rect
        data-figma-bg-blur-radius='2.07677'
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 74.4245 113.425)'
        fill='var(--purple)'
        fillOpacity='0.5'
      />
      <foreignObject x='23.2496' y='110.695' width='28.8662' height='28.8664'>
        <div
          style={{
            backdropFilter: 'blur(1.04px);clipPath:url(#bgblur_2_3383_10956_clip_path',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <rect
        data-figma-bg-blur-radius='2.07677'
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 50.039 113.099)'
        fill='var(--purple)'
        fillOpacity='0.5'
      />
      <rect
        opacity='0.5'
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 147.003 138.752)'
        fill='var(--purple)'
      />
      <rect
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 98.9343 89.3633)'
        fill='var(--purple)'
      />
      <rect
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 98.6075 113.749)'
        fill='var(--purple)'
      />
      <rect
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.0133936 0.99991 0.99991 0.0133936 50.3656 88.7129)'
        fill='var(--purple)'
      />
      <rect
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 122.994 114.076)'
        fill='var(--purple)'
      />
      <rect
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 74.0977 137.811)'
        fill='var(--purple)'
      />
      <rect
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 122.668 138.462)'
        fill='var(--purple)'
      />
      <rect
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.0133936 0.99991 0.99991 0.0133936 75.0779 64.6533)'
        fill='var(--purple)'
      />
      <rect
        width='24.3882'
        height='24.3882'
        transform='matrix(-0.0133936 0.99991 0.99991 0.0133936 26.3065 64)'
        fill='var(--purple)'
      />
      <rect
        opacity='0.5'
        x='267.662'
        y='368.69'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 267.662 368.69)'
        fill='var(--purple)'
      />
      <foreignObject x='313.828' y='341.25' width='28.8662' height='28.8664'>
        <div
          style={{
            backdropFilter: 'blur(1.04px);clipPath:url(#bgblur_3_3383_10956_clip_path',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <rect
        data-figma-bg-blur-radius='2.07677'
        x='315.905'
        y='343.653'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 315.905 343.653)'
        fill='var(--purple)'
        fillOpacity='0.5'
      />
      <foreignObject x='314.482' y='390.022' width='28.8662' height='28.8664'>
        <div
          style={{
            backdropFilter: 'blur(1.04px);clipPath:url(#bgblur_4_3383_10956_clip_path',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <rect
        data-figma-bg-blur-radius='2.07677'
        x='316.559'
        y='392.425'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 316.559 392.425)'
        fill='var(--purple)'
        fillOpacity='0.5'
      />
      <foreignObject x='338.867' y='389.695' width='28.8662' height='28.8664'>
        <div
          style={{
            backdropFilter: 'blur(1.04px);clipPath:url(#bgblur_5_3383_10956_clip_path',
            height: '100%',
            width: '100%',
          }}
        />
      </foreignObject>
      <rect
        data-figma-bg-blur-radius='2.07677'
        x='340.944'
        y='392.099'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 340.944 392.099)'
        fill='var(--purple)'
        fillOpacity='0.5'
      />
      <rect
        opacity='0.5'
        x='243.98'
        y='417.752'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 243.98 417.752)'
        fill='var(--purple)'
      />
      <rect
        x='292.049'
        y='368.363'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 292.049 368.363)'
        fill='var(--purple)'
      />
      <rect
        x='292.376'
        y='392.749'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 292.376 392.749)'
        fill='var(--purple)'
      />
      <rect
        x='340.617'
        y='367.713'
        width='24.3882'
        height='24.3882'
        transform='rotate(89.2326 340.617 367.713)'
        fill='var(--purple)'
      />
      <rect
        x='267.989'
        y='393.076'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 267.989 393.076)'
        fill='var(--purple)'
      />
      <rect
        x='316.885'
        y='416.811'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 316.885 416.811)'
        fill='var(--purple)'
      />
      <rect
        x='268.316'
        y='417.462'
        width='24.3882'
        height='24.3882'
        transform='rotate(-0.767422 268.316 417.462)'
        fill='var(--purple)'
      />
      <rect
        x='315.905'
        y='343.653'
        width='24.3882'
        height='24.3882'
        transform='rotate(89.2326 315.905 343.653)'
        fill='var(--purple)'
      />
      <rect
        x='364.677'
        y='343'
        width='24.3882'
        height='24.3882'
        transform='rotate(89.2326 364.677 343)'
        fill='var(--purple)'
      />
      <circle cx='114.848' cy='186.873' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='131.386' cy='203.411' r='0.424051' fill='black' fillOpacity='0.5' />
      <circle cx='147.924' cy='188.57' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='131.386' cy='180.513' r='0.424051' fill='black' fillOpacity='0.5' />
      <circle cx='154.709' cy='175.848' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='169.975' cy='196.203' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='161.494' cy='202.987' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='172.095' cy='185.601' r='0.424051' fill='black' fillOpacity='0.5' />
      <circle cx='192.873' cy='178.393' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='204.323' cy='190.69' r='0.424051' fill='black' fillOpacity='0.5' />
      <circle cx='192.449' cy='206.804' r='1.27215' fill='black' fillOpacity='0.5' />
      <rect x='151.378' y='189.956' width='89.8405' height='8.09374' fill='#AA8DFF' />
      <rect x='151.378' y='303.269' width='89.8405' height='8.09374' fill='#AA8DFF' />
      <rect width='8.09374' height='8.09374' transform='matrix(-1 0 0 1 151.378 198.05)' fill='#AA8DFF' />
      <rect width='8.09374' height='8.09374' transform='matrix(-1 0 0 1 249.312 198.05)' fill='#AA8DFF' />
      <rect width='8.09374' height='8.09374' transform='matrix(-1 0 0 1 152.188 295.984)' fill='#AA8DFF' />
      <path d='M257 206.296H248.906V296.946H257V206.296Z' fill='#AA8DFF' />
      <rect width='8.09374' height='90.6499' transform='matrix(-1 0 0 1 144.094 205.334)' fill='#AA8DFF' />
      <circle cx='183.848' cy='306.874' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='200.386' cy='323.411' r='0.424051' fill='black' fillOpacity='0.5' />
      <circle cx='216.924' cy='308.569' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='200.386' cy='300.512' r='0.424051' fill='black' fillOpacity='0.5' />
      <circle cx='223.709' cy='295.848' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='238.975' cy='316.202' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='230.494' cy='322.987' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='241.095' cy='305.601' r='0.424051' fill='black' fillOpacity='0.5' />
      <circle cx='261.873' cy='298.392' r='0.848101' fill='black' fillOpacity='0.5' />
      <circle cx='273.323' cy='310.69' r='0.424051' fill='black' fillOpacity='0.5' />
      <circle cx='261.449' cy='326.803' r='1.27215' fill='black' fillOpacity='0.5' />
      <path
        d='M241.106 198.387H151.737V206.256H144.431L143.869 295.624H152.3V303.493L241.106 302.931V296.186H249.537L248.975 206.256H241.106V198.387Z'
        fill='var(--purple)'
      />
      <path
        d='M241.106 198.387H151.737V206.256H144.431L143.869 295.624H152.3V303.493L241.106 302.931V296.186H249.537L248.975 206.256H241.106V198.387Z'
        fill='url(#paint120_linear_3383_10956)'
        fillOpacity='0.1'
      />
      <path
        d='M199.714 226H204.893V231.179H210.072V236.357H189.357V246.714H210.072V251.893H189.357V262.25H210.072V267.429H204.893V272.608H199.714V267.429H194.536V272.608H189.357V267.429H179V262.25H184.179V251.893H179V246.714H184.179V236.357H179V231.179H189.357V226H194.536V231.179H199.714V226ZM210.072 262.25V251.893H215.25V262.25H210.072ZM210.072 246.714V236.357H215.25V246.714H210.072Z'
        fill='var(--white)'
      />
      <path
        d='M240.777 197.937V205.917H151.219L152.439 295.474H144.126V205.917H151.219V197.937H240.777Z'
        fill='#5E33DC'
      />
      <path
        d='M241.663 206.804H248.757V295.474H240.777V303.455H152.106V296.361L240.777 295.474L241.663 206.804Z'
        fill='#291170'
      />
      <rect width='8.09374' height='8.09374' transform='matrix(-1 0 0 1 166.756 212.619)' fill='var(--white)' />
      <rect width='8.09374' height='8.09374' transform='matrix(-1 0 0 1 234.743 212.619)' fill='var(--white)' />
      <rect width='8.09374' height='8.09374' transform='matrix(-1 0 0 1 234.743 280.606)' fill='var(--white)' />
      <rect width='8.09374' height='8.09374' transform='matrix(-1 0 0 1 166.756 280.606)' fill='var(--white)' />
      <rect width='8.09374' height='8.09374' transform='matrix(-1 0 0 1 249.312 295.984)' fill='var(--purple)' />
      <defs>
        <clipPath id='paint0_angular_3383_10956_clip_path'>
          <path
            d='M59.9 76.9V77.9H60.9V76.9H59.9ZM26 76.9H25V77.9H26V76.9ZM58.9 43V76.9H60.9V43H58.9ZM59.9 75.9H26V77.9H59.9V75.9ZM27 76.9V43H25V76.9H27Z'
            mask='url(#path-1-inside-1_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint1_angular_3383_10956_clip_path'>
          <path
            d='M93.8 76.9V77.9H94.8V76.9H93.8ZM92.8 43V76.9H94.8V43H92.8ZM93.8 75.9H59.9V77.9H93.8V75.9Z'
            mask='url(#path-4-inside-2_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint2_angular_3383_10956_clip_path'>
          <path
            d='M127.7 76.9V77.9H128.7V76.9H127.7ZM126.7 43V76.9H128.7V43H126.7ZM127.7 75.9H93.8V77.9H127.7V75.9Z'
            mask='url(#path-7-inside-3_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint3_angular_3383_10956_clip_path'>
          <path
            d='M161.6 76.9V77.9H162.6V76.9H161.6ZM160.6 43V76.9H162.6V43H160.6ZM161.6 75.9H127.7V77.9H161.6V75.9Z'
            mask='url(#path-10-inside-4_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint4_angular_3383_10956_clip_path'>
          <path
            d='M195.5 76.9V77.9H196.5V76.9H195.5ZM194.5 43V76.9H196.5V43H194.5ZM195.5 75.9H161.6V77.9H195.5V75.9Z'
            mask='url(#path-13-inside-5_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint5_angular_3383_10956_clip_path'>
          <path
            d='M229.4 76.9V77.9H230.4V76.9H229.4ZM228.4 43V76.9H230.4V43H228.4ZM229.4 75.9H195.5V77.9H229.4V75.9Z'
            mask='url(#path-16-inside-6_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint6_angular_3383_10956_clip_path'>
          <path
            d='M263.3 76.9V77.9H264.3V76.9H263.3ZM262.3 43V76.9H264.3V43H262.3ZM263.3 75.9H229.4V77.9H263.3V75.9Z'
            mask='url(#path-28-inside-7_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint7_angular_3383_10956_clip_path'>
          <path
            d='M297.2 76.9V77.9H298.2V76.9H297.2ZM296.2 43V76.9H298.2V43H296.2ZM297.2 75.9H263.3V77.9H297.2V75.9Z'
            mask='url(#path-31-inside-8_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint8_angular_3383_10956_clip_path'>
          <path
            d='M331.1 76.9V77.9H332.1V76.9H331.1ZM330.1 43V76.9H332.1V43H330.1ZM331.1 75.9H297.2V77.9H331.1V75.9Z'
            mask='url(#path-34-inside-9_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint9_angular_3383_10956_clip_path'>
          <path
            d='M365 76.9V77.9H366V76.9H365ZM364 43V76.9H366V43H364ZM365 75.9H331.1V77.9H365V75.9Z'
            mask='url(#path-37-inside-10_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint10_angular_3383_10956_clip_path'>
          <path
            d='M59.9 110.9V111.9H60.9V110.9H59.9ZM26 110.9H25V111.9H26V110.9ZM58.9 77V110.9H60.9V77H58.9ZM59.9 109.9H26V111.9H59.9V109.9ZM27 110.9V77H25V110.9H27Z'
            mask='url(#path-49-inside-11_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint11_angular_3383_10956_clip_path'>
          <path
            d='M93.8 110.9V111.9H94.8V110.9H93.8ZM92.8 77V110.9H94.8V77H92.8ZM93.8 109.9H59.9V111.9H93.8V109.9Z'
            mask='url(#path-52-inside-12_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint12_angular_3383_10956_clip_path'>
          <path
            d='M127.7 110.9V111.9H128.7V110.9H127.7ZM126.7 77V110.9H128.7V77H126.7ZM127.7 109.9H93.8V111.9H127.7V109.9Z'
            mask='url(#path-55-inside-13_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint13_angular_3383_10956_clip_path'>
          <path
            d='M161.6 110.9V111.9H162.6V110.9H161.6ZM160.6 77V110.9H162.6V77H160.6ZM161.6 109.9H127.7V111.9H161.6V109.9Z'
            mask='url(#path-58-inside-14_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint14_angular_3383_10956_clip_path'>
          <path
            d='M195.5 110.9V111.9H196.5V110.9H195.5ZM194.5 77V110.9H196.5V77H194.5ZM195.5 109.9H161.6V111.9H195.5V109.9Z'
            mask='url(#path-61-inside-15_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint15_angular_3383_10956_clip_path'>
          <path
            d='M229.4 110.9V111.9H230.4V110.9H229.4ZM228.4 77V110.9H230.4V77H228.4ZM229.4 109.9H195.5V111.9H229.4V109.9Z'
            mask='url(#path-66-inside-16_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint16_angular_3383_10956_clip_path'>
          <path
            d='M263.3 110.9V111.9H264.3V110.9H263.3ZM262.3 77V110.9H264.3V77H262.3ZM263.3 109.9H229.4V111.9H263.3V109.9Z'
            mask='url(#path-69-inside-17_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint17_angular_3383_10956_clip_path'>
          <path
            d='M297.2 110.9V111.9H298.2V110.9H297.2ZM296.2 77V110.9H298.2V77H296.2ZM297.2 109.9H263.3V111.9H297.2V109.9Z'
            mask='url(#path-81-inside-18_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint18_angular_3383_10956_clip_path'>
          <path
            d='M331.1 110.9V111.9H332.1V110.9H331.1ZM330.1 77V110.9H332.1V77H330.1ZM331.1 109.9H297.2V111.9H331.1V109.9Z'
            mask='url(#path-84-inside-19_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint19_angular_3383_10956_clip_path'>
          <path
            d='M365 110.9V111.9H366V110.9H365ZM364 77V110.9H366V77H364ZM365 109.9H331.1V111.9H365V109.9Z'
            mask='url(#path-87-inside-20_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint20_angular_3383_10956_clip_path'>
          <path
            d='M59.9 144.9V145.9H60.9V144.9H59.9ZM26 144.9H25V145.9H26V144.9ZM58.9 111V144.9H60.9V111H58.9ZM59.9 143.9H26V145.9H59.9V143.9ZM27 144.9V111H25V144.9H27Z'
            mask='url(#path-90-inside-21_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint21_angular_3383_10956_clip_path'>
          <path
            d='M93.8 144.9V145.9H94.8V144.9H93.8ZM92.8 111V144.9H94.8V111H92.8ZM93.8 143.9H59.9V145.9H93.8V143.9Z'
            mask='url(#path-93-inside-22_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint22_angular_3383_10956_clip_path'>
          <path
            d='M127.7 144.9V145.9H128.7V144.9H127.7ZM126.7 111V144.9H128.7V111H126.7ZM127.7 143.9H93.8V145.9H127.7V143.9Z'
            mask='url(#path-96-inside-23_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint23_angular_3383_10956_clip_path'>
          <path
            d='M161.6 144.9V145.9H162.6V144.9H161.6ZM160.6 111V144.9H162.6V111H160.6ZM161.6 143.9H127.7V145.9H161.6V143.9Z'
            mask='url(#path-99-inside-24_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint24_angular_3383_10956_clip_path'>
          <path
            d='M195.5 144.9V145.9H196.5V144.9H195.5ZM194.5 111V144.9H196.5V111H194.5ZM195.5 143.9H161.6V145.9H195.5V143.9Z'
            mask='url(#path-102-inside-25_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint25_angular_3383_10956_clip_path'>
          <path
            d='M229.4 144.9V145.9H230.4V144.9H229.4ZM228.4 111V144.9H230.4V111H228.4ZM229.4 143.9H195.5V145.9H229.4V143.9Z'
            mask='url(#path-105-inside-26_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint26_angular_3383_10956_clip_path'>
          <path
            d='M263.3 144.9V145.9H264.3V144.9H263.3ZM262.3 111V144.9H264.3V111H262.3ZM263.3 143.9H229.4V145.9H263.3V143.9Z'
            mask='url(#path-108-inside-27_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint27_angular_3383_10956_clip_path'>
          <path
            d='M297.2 144.9V145.9H298.2V144.9H297.2ZM296.2 111V144.9H298.2V111H296.2ZM297.2 143.9H263.3V145.9H297.2V143.9Z'
            mask='url(#path-113-inside-28_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint28_angular_3383_10956_clip_path'>
          <path
            d='M331.1 144.9V145.9H332.1V144.9H331.1ZM330.1 111V144.9H332.1V111H330.1ZM331.1 143.9H297.2V145.9H331.1V143.9Z'
            mask='url(#path-116-inside-29_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint29_angular_3383_10956_clip_path'>
          <path
            d='M365 144.9V145.9H366V144.9H365ZM364 111V144.9H366V111H364ZM365 143.9H331.1V145.9H365V143.9Z'
            mask='url(#path-128-inside-30_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint30_angular_3383_10956_clip_path'>
          <path
            d='M59.9 178.9V179.9H60.9V178.9H59.9ZM26 178.9H25V179.9H26V178.9ZM58.9 145V178.9H60.9V145H58.9ZM59.9 177.9H26V179.9H59.9V177.9ZM27 178.9V145H25V178.9H27Z'
            mask='url(#path-131-inside-31_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint31_angular_3383_10956_clip_path'>
          <path
            d='M93.8 178.9V179.9H94.8V178.9H93.8ZM92.8 145V178.9H94.8V145H92.8ZM93.8 177.9H59.9V179.9H93.8V177.9Z'
            mask='url(#path-134-inside-32_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint32_angular_3383_10956_clip_path'>
          <path
            d='M127.7 178.9V179.9H128.7V178.9H127.7ZM126.7 145V178.9H128.7V145H126.7ZM127.7 177.9H93.8V179.9H127.7V177.9Z'
            mask='url(#path-137-inside-33_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint33_angular_3383_10956_clip_path'>
          <path
            d='M161.6 178.9V179.9H162.6V178.9H161.6ZM160.6 145V178.9H162.6V145H160.6ZM161.6 177.9H127.7V179.9H161.6V177.9Z'
            mask='url(#path-140-inside-34_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint34_angular_3383_10956_clip_path'>
          <path
            d='M195.5 178.9V179.9H196.5V178.9H195.5ZM194.5 145V178.9H196.5V145H194.5ZM195.5 177.9H161.6V179.9H195.5V177.9Z'
            mask='url(#path-143-inside-35_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint35_angular_3383_10956_clip_path'>
          <path
            d='M229.4 178.9V179.9H230.4V178.9H229.4ZM228.4 145V178.9H230.4V145H228.4ZM229.4 177.9H195.5V179.9H229.4V177.9Z'
            mask='url(#path-146-inside-36_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint36_angular_3383_10956_clip_path'>
          <path
            d='M263.3 178.9V179.9H264.3V178.9H263.3ZM262.3 145V178.9H264.3V145H262.3ZM263.3 177.9H229.4V179.9H263.3V177.9Z'
            mask='url(#path-149-inside-37_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint37_angular_3383_10956_clip_path'>
          <path
            d='M297.2 178.9V179.9H298.2V178.9H297.2ZM296.2 145V178.9H298.2V145H296.2ZM297.2 177.9H263.3V179.9H297.2V177.9Z'
            mask='url(#path-152-inside-38_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint38_angular_3383_10956_clip_path'>
          <path
            d='M331.1 178.9V179.9H332.1V178.9H331.1ZM330.1 145V178.9H332.1V145H330.1ZM331.1 177.9H297.2V179.9H331.1V177.9Z'
            mask='url(#path-155-inside-39_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint39_angular_3383_10956_clip_path'>
          <path
            d='M365 178.9V179.9H366V178.9H365ZM364 145V178.9H366V145H364ZM365 177.9H331.1V179.9H365V177.9Z'
            mask='url(#path-158-inside-40_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint40_angular_3383_10956_clip_path'>
          <path
            d='M59.9 212.9V213.9H60.9V212.9H59.9ZM26 212.9H25V213.9H26V212.9ZM58.9 179V212.9H60.9V179H58.9ZM59.9 211.9H26V213.9H59.9V211.9ZM27 212.9V179H25V212.9H27Z'
            mask='url(#path-163-inside-41_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint41_angular_3383_10956_clip_path'>
          <path
            d='M93.8 212.9V213.9H94.8V212.9H93.8ZM92.8 179V212.9H94.8V179H92.8ZM93.8 211.9H59.9V213.9H93.8V211.9Z'
            mask='url(#path-168-inside-42_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint42_angular_3383_10956_clip_path'>
          <path
            d='M127.7 212.9V213.9H128.7V212.9H127.7ZM126.7 179V212.9H128.7V179H126.7ZM127.7 211.9H93.8V213.9H127.7V211.9Z'
            mask='url(#path-171-inside-43_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint43_angular_3383_10956_clip_path'>
          <path
            d='M161.6 212.9V213.9H162.6V212.9H161.6ZM160.6 179V212.9H162.6V179H160.6ZM161.6 211.9H127.7V213.9H161.6V211.9Z'
            mask='url(#path-174-inside-44_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint44_angular_3383_10956_clip_path'>
          <path
            d='M195.5 212.9V213.9H196.5V212.9H195.5ZM161.6 212.9H160.6V213.9H161.6V212.9ZM194.5 179V212.9H196.5V179H194.5ZM195.5 211.9H161.6V213.9H195.5V211.9ZM162.6 212.9V179H160.6V212.9H162.6Z'
            mask='url(#path-177-inside-45_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint45_angular_3383_10956_clip_path'>
          <path
            d='M229.4 212.9V213.9H230.4V212.9H229.4ZM228.4 179V212.9H230.4V179H228.4ZM229.4 211.9H195.5V213.9H229.4V211.9Z'
            mask='url(#path-180-inside-46_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint46_angular_3383_10956_clip_path'>
          <path
            d='M263.3 212.9V213.9H264.3V212.9H263.3ZM262.3 179V212.9H264.3V179H262.3ZM263.3 211.9H229.4V213.9H263.3V211.9Z'
            mask='url(#path-183-inside-47_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint47_angular_3383_10956_clip_path'>
          <path
            d='M297.2 212.9V213.9H298.2V212.9H297.2ZM296.2 179V212.9H298.2V179H296.2ZM297.2 211.9H263.3V213.9H297.2V211.9Z'
            mask='url(#path-186-inside-48_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint48_angular_3383_10956_clip_path'>
          <path
            d='M331.1 212.9V213.9H332.1V212.9H331.1ZM330.1 179V212.9H332.1V179H330.1ZM331.1 211.9H297.2V213.9H331.1V211.9Z'
            mask='url(#path-189-inside-49_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint49_angular_3383_10956_clip_path'>
          <path
            d='M365 212.9V213.9H366V212.9H365ZM364 179V212.9H366V179H364ZM365 211.9H331.1V213.9H365V211.9Z'
            mask='url(#path-192-inside-50_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint50_angular_3383_10956_clip_path'>
          <path
            d='M59.9 246.9V247.9H60.9V246.9H59.9ZM58.9 213V246.9H60.9V213H58.9ZM59.9 245.9H26V247.9H59.9V245.9Z'
            mask='url(#path-195-inside-51_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint51_angular_3383_10956_clip_path'>
          <path
            d='M93.8 246.9V247.9H94.8V246.9H93.8ZM92.8 213V246.9H94.8V213H92.8ZM93.8 245.9H59.9V247.9H93.8V245.9Z'
            mask='url(#path-198-inside-52_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint52_angular_3383_10956_clip_path'>
          <path
            d='M127.7 246.9V247.9H128.7V246.9H127.7ZM126.7 213V246.9H128.7V213H126.7ZM127.7 245.9H93.8V247.9H127.7V245.9Z'
            mask='url(#path-201-inside-53_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint53_angular_3383_10956_clip_path'>
          <path
            d='M161.6 246.9V247.9H162.6V246.9H161.6ZM160.6 213V246.9H162.6V213H160.6ZM161.6 245.9H127.7V247.9H161.6V245.9Z'
            mask='url(#path-204-inside-54_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint54_angular_3383_10956_clip_path'>
          <path
            d='M195.5 246.9V247.9H196.5V246.9H195.5ZM161.6 246.9H160.6V247.9H161.6V246.9ZM194.5 213V246.9H196.5V213H194.5ZM195.5 245.9H161.6V247.9H195.5V245.9ZM162.6 246.9V213H160.6V246.9H162.6Z'
            mask='url(#path-207-inside-55_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint55_angular_3383_10956_clip_path'>
          <path
            d='M229.4 246.9V247.9H230.4V246.9H229.4ZM228.4 213V246.9H230.4V213H228.4ZM229.4 245.9H195.5V247.9H229.4V245.9Z'
            mask='url(#path-210-inside-56_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint56_angular_3383_10956_clip_path'>
          <path
            d='M263.3 246.9V247.9H264.3V246.9H263.3ZM262.3 213V246.9H264.3V213H262.3ZM263.3 245.9H229.4V247.9H263.3V245.9Z'
            mask='url(#path-214-inside-58_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint57_angular_3383_10956_clip_path'>
          <path
            d='M297.2 246.9V247.9H298.2V246.9H297.2ZM296.2 213V246.9H298.2V213H296.2ZM297.2 245.9H263.3V247.9H297.2V245.9Z'
            mask='url(#path-217-inside-59_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint58_angular_3383_10956_clip_path'>
          <path
            d='M331.1 246.9V247.9H332.1V246.9H331.1ZM330.1 213V246.9H332.1V213H330.1ZM331.1 245.9H297.2V247.9H331.1V245.9Z'
            mask='url(#path-220-inside-60_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint59_angular_3383_10956_clip_path'>
          <path
            d='M365 246.9V247.9H366V246.9H365ZM364 213V246.9H366V213H364ZM365 245.9H331.1V247.9H365V245.9Z'
            mask='url(#path-232-inside-61_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint60_angular_3383_10956_clip_path'>
          <path
            d='M59.9 280.9V281.9H60.9V280.9H59.9ZM58.9 247V280.9H60.9V247H58.9ZM59.9 279.9H26V281.9H59.9V279.9Z'
            mask='url(#path-235-inside-62_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint61_angular_3383_10956_clip_path'>
          <path
            d='M93.8 280.9V281.9H94.8V280.9H93.8ZM92.8 247V280.9H94.8V247H92.8ZM93.8 279.9H59.9V281.9H93.8V279.9Z'
            mask='url(#path-240-inside-63_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint62_angular_3383_10956_clip_path'>
          <path
            d='M127.7 280.9V281.9H128.7V280.9H127.7ZM126.7 247V280.9H128.7V247H126.7ZM127.7 279.9H93.8V281.9H127.7V279.9Z'
            mask='url(#path-243-inside-64_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint63_angular_3383_10956_clip_path'>
          <path
            d='M161.6 280.9V281.9H162.6V280.9H161.6ZM160.6 247V280.9H162.6V247H160.6ZM161.6 279.9H127.7V281.9H161.6V279.9Z'
            mask='url(#path-246-inside-65_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint64_angular_3383_10956_clip_path'>
          <path
            d='M195.5 280.9V281.9H196.5V280.9H195.5ZM161.6 280.9H160.6V281.9H161.6V280.9ZM194.5 247V280.9H196.5V247H194.5ZM195.5 279.9H161.6V281.9H195.5V279.9ZM162.6 280.9V247H160.6V280.9H162.6Z'
            mask='url(#path-249-inside-66_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint65_angular_3383_10956_clip_path'>
          <path
            d='M229.4 280.9V281.9H230.4V280.9H229.4ZM228.4 247V280.9H230.4V247H228.4ZM229.4 279.9H195.5V281.9H229.4V279.9Z'
            mask='url(#path-252-inside-67_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint66_angular_3383_10956_clip_path'>
          <path
            d='M263.3 280.9V281.9H264.3V280.9H263.3ZM262.3 247V280.9H264.3V247H262.3ZM263.3 279.9H229.4V281.9H263.3V279.9Z'
            mask='url(#path-255-inside-68_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint67_angular_3383_10956_clip_path'>
          <path
            d='M297.2 280.9V281.9H298.2V280.9H297.2ZM296.2 247V280.9H298.2V247H296.2ZM297.2 279.9H263.3V281.9H297.2V279.9Z'
            mask='url(#path-258-inside-69_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint68_angular_3383_10956_clip_path'>
          <path
            d='M331.1 280.9V281.9H332.1V280.9H331.1ZM330.1 247V280.9H332.1V247H330.1ZM331.1 279.9H297.2V281.9H331.1V279.9Z'
            mask='url(#path-261-inside-70_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint69_angular_3383_10956_clip_path'>
          <path
            d='M365 280.9V281.9H366V280.9H365ZM364 247V280.9H366V247H364ZM365 279.9H331.1V281.9H365V279.9Z'
            mask='url(#path-264-inside-71_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint70_angular_3383_10956_clip_path'>
          <path
            d='M59.9 314.9V315.9H60.9V314.9H59.9ZM58.9 281V314.9H60.9V281H58.9ZM59.9 313.9H26V315.9H59.9V313.9Z'
            mask='url(#path-267-inside-72_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint71_angular_3383_10956_clip_path'>
          <path
            d='M93.8 314.9V315.9H94.8V314.9H93.8ZM92.8 281V314.9H94.8V281H92.8ZM93.8 313.9H59.9V315.9H93.8V313.9Z'
            mask='url(#path-270-inside-73_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint72_angular_3383_10956_clip_path'>
          <path
            d='M127.7 314.9V315.9H128.7V314.9H127.7ZM126.7 281V314.9H128.7V281H126.7ZM127.7 313.9H93.8V315.9H127.7V313.9Z'
            mask='url(#path-282-inside-74_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint73_angular_3383_10956_clip_path'>
          <path
            d='M161.6 314.9V315.9H162.6V314.9H161.6ZM160.6 281V314.9H162.6V281H160.6ZM161.6 313.9H127.7V315.9H161.6V313.9Z'
            mask='url(#path-285-inside-75_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint74_angular_3383_10956_clip_path'>
          <path
            d='M195.5 314.9V315.9H196.5V314.9H195.5ZM194.5 281V314.9H196.5V281H194.5ZM195.5 313.9H161.6V315.9H195.5V313.9Z'
            mask='url(#path-288-inside-76_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint75_angular_3383_10956_clip_path'>
          <path
            d='M229.4 314.9V315.9H230.4V314.9H229.4ZM195.5 314.9H194.5V315.9H195.5V314.9ZM228.4 281V314.9H230.4V281H228.4ZM229.4 313.9H195.5V315.9H229.4V313.9ZM196.5 314.9V281H194.5V314.9H196.5Z'
            mask='url(#path-291-inside-77_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint76_angular_3383_10956_clip_path'>
          <path
            d='M263.3 314.9V315.9H264.3V314.9H263.3ZM262.3 281V314.9H264.3V281H262.3ZM263.3 313.9H229.4V315.9H263.3V313.9Z'
            mask='url(#path-294-inside-78_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint77_angular_3383_10956_clip_path'>
          <path
            d='M297.2 314.9V315.9H298.2V314.9H297.2ZM296.2 281V314.9H298.2V281H296.2ZM297.2 313.9H263.3V315.9H297.2V313.9Z'
            mask='url(#path-297-inside-79_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint78_angular_3383_10956_clip_path'>
          <path
            d='M331.1 314.9V315.9H332.1V314.9H331.1ZM330.1 281V314.9H332.1V281H330.1ZM331.1 313.9H297.2V315.9H331.1V313.9Z'
            mask='url(#path-300-inside-80_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint79_angular_3383_10956_clip_path'>
          <path
            d='M365 314.9V315.9H366V314.9H365ZM364 281V314.9H366V281H364ZM365 313.9H331.1V315.9H365V313.9Z'
            mask='url(#path-303-inside-81_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint80_angular_3383_10956_clip_path'>
          <path
            d='M59.9 348.9V349.9H60.9V348.9H59.9ZM58.9 315V348.9H60.9V315H58.9ZM59.9 347.9H26V349.9H59.9V347.9Z'
            mask='url(#path-306-inside-82_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint81_angular_3383_10956_clip_path'>
          <path
            d='M93.8 348.9V349.9H94.8V348.9H93.8ZM92.8 315V348.9H94.8V315H92.8ZM93.8 347.9H59.9V349.9H93.8V347.9Z'
            mask='url(#path-309-inside-83_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint82_angular_3383_10956_clip_path'>
          <path
            d='M127.7 348.9V349.9H128.7V348.9H127.7ZM126.7 315V348.9H128.7V315H126.7ZM127.7 347.9H93.8V349.9H127.7V347.9Z'
            mask='url(#path-321-inside-84_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint83_angular_3383_10956_clip_path'>
          <path
            d='M161.6 348.9V349.9H162.6V348.9H161.6ZM160.6 315V348.9H162.6V315H160.6ZM161.6 347.9H127.7V349.9H161.6V347.9Z'
            mask='url(#path-324-inside-85_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint84_angular_3383_10956_clip_path'>
          <path
            d='M195.5 348.9V349.9H196.5V348.9H195.5ZM194.5 315V348.9H196.5V315H194.5ZM195.5 347.9H161.6V349.9H195.5V347.9Z'
            mask='url(#path-327-inside-86_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint85_angular_3383_10956_clip_path'>
          <path
            d='M229.4 348.9V349.9H230.4V348.9H229.4ZM228.4 315V348.9H230.4V315H228.4ZM229.4 347.9H195.5V349.9H229.4V347.9Z'
            mask='url(#path-332-inside-87_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint86_angular_3383_10956_clip_path'>
          <path
            d='M263.3 348.9V349.9H264.3V348.9H263.3ZM262.3 315V348.9H264.3V315H262.3ZM263.3 347.9H229.4V349.9H263.3V347.9Z'
            mask='url(#path-335-inside-88_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint87_angular_3383_10956_clip_path'>
          <path
            d='M297.2 348.9V349.9H298.2V348.9H297.2ZM296.2 315V348.9H298.2V315H296.2ZM297.2 347.9H263.3V349.9H297.2V347.9Z'
            mask='url(#path-338-inside-89_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint88_angular_3383_10956_clip_path'>
          <path
            d='M331.1 348.9V349.9H332.1V348.9H331.1ZM330.1 315V348.9H332.1V315H330.1ZM331.1 347.9H297.2V349.9H331.1V347.9Z'
            mask='url(#path-341-inside-90_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint89_angular_3383_10956_clip_path'>
          <path
            d='M365 348.9V349.9H366V348.9H365ZM364 315V348.9H366V315H364ZM365 347.9H331.1V349.9H365V347.9Z'
            mask='url(#path-344-inside-91_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint90_angular_3383_10956_clip_path'>
          <path
            d='M59.9 382.9V383.9H60.9V382.9H59.9ZM26 382.9H25V383.9H26V382.9ZM58.9 349V382.9H60.9V349H58.9ZM59.9 381.9H26V383.9H59.9V381.9ZM27 382.9V349H25V382.9H27Z'
            mask='url(#path-347-inside-92_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint91_angular_3383_10956_clip_path'>
          <path
            d='M93.8 382.9V383.9H94.8V382.9H93.8ZM92.8 349V382.9H94.8V349H92.8ZM93.8 381.9H59.9V383.9H93.8V381.9Z'
            mask='url(#path-350-inside-93_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint92_angular_3383_10956_clip_path'>
          <path
            d='M127.7 382.9V383.9H128.7V382.9H127.7ZM126.7 349V382.9H128.7V349H126.7ZM127.7 381.9H93.8V383.9H127.7V381.9Z'
            mask='url(#path-353-inside-94_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint93_angular_3383_10956_clip_path'>
          <path
            d='M161.6 382.9V383.9H162.6V382.9H161.6ZM160.6 349V382.9H162.6V349H160.6ZM161.6 381.9H127.7V383.9H161.6V381.9Z'
            mask='url(#path-356-inside-95_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint94_angular_3383_10956_clip_path'>
          <path
            d='M195.5 382.9V383.9H196.5V382.9H195.5ZM194.5 349V382.9H196.5V349H194.5ZM195.5 381.9H161.6V383.9H195.5V381.9Z'
            mask='url(#path-359-inside-96_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint95_angular_3383_10956_clip_path'>
          <path
            d='M229.4 382.9V383.9H230.4V382.9H229.4ZM228.4 349V382.9H230.4V349H228.4ZM229.4 381.9H195.5V383.9H229.4V381.9Z'
            mask='url(#path-364-inside-97_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint96_angular_3383_10956_clip_path'>
          <path
            d='M263.3 382.9V383.9H264.3V382.9H263.3ZM262.3 349V382.9H264.3V349H262.3ZM263.3 381.9H229.4V383.9H263.3V381.9Z'
            mask='url(#path-367-inside-98_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint97_angular_3383_10956_clip_path'>
          <path
            d='M297.2 382.9V383.9H298.2V382.9H297.2ZM296.2 349V382.9H298.2V349H296.2ZM297.2 381.9H263.3V383.9H297.2V381.9Z'
            mask='url(#path-370-inside-99_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint98_angular_3383_10956_clip_path'>
          <path
            d='M331.1 382.9V383.9H332.1V382.9H331.1ZM330.1 349V382.9H332.1V349H330.1ZM331.1 381.9H297.2V383.9H331.1V381.9Z'
            mask='url(#path-373-inside-100_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint99_angular_3383_10956_clip_path'>
          <path
            d='M365 382.9V383.9H366V382.9H365ZM364 349V382.9H366V349H364ZM365 381.9H331.1V383.9H365V381.9Z'
            mask='url(#path-377-inside-102_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint100_angular_3383_10956_clip_path'>
          <path
            d='M59.9 416.9V417.9H60.9V416.9H59.9ZM26 416.9H25V417.9H26V416.9ZM58.9 383V416.9H60.9V383H58.9ZM59.9 415.9H26V417.9H59.9V415.9ZM27 416.9V383H25V416.9H27Z'
            mask='url(#path-380-inside-103_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint101_angular_3383_10956_clip_path'>
          <path
            d='M93.8 416.9V417.9H94.8V416.9H93.8ZM92.8 383V416.9H94.8V383H92.8ZM93.8 415.9H59.9V417.9H93.8V415.9Z'
            mask='url(#path-383-inside-104_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint102_angular_3383_10956_clip_path'>
          <path
            d='M127.7 416.9V417.9H128.7V416.9H127.7ZM126.7 383V416.9H128.7V383H126.7ZM127.7 415.9H93.8V417.9H127.7V415.9Z'
            mask='url(#path-386-inside-105_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint103_angular_3383_10956_clip_path'>
          <path
            d='M161.6 416.9V417.9H162.6V416.9H161.6ZM160.6 383V416.9H162.6V383H160.6ZM161.6 415.9H127.7V417.9H161.6V415.9Z'
            mask='url(#path-389-inside-106_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint104_angular_3383_10956_clip_path'>
          <path
            d='M195.5 416.9V417.9H196.5V416.9H195.5ZM194.5 383V416.9H196.5V383H194.5ZM195.5 415.9H161.6V417.9H195.5V415.9Z'
            mask='url(#path-392-inside-107_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint105_angular_3383_10956_clip_path'>
          <path
            d='M229.4 416.9V417.9H230.4V416.9H229.4ZM228.4 383V416.9H230.4V383H228.4ZM229.4 415.9H195.5V417.9H229.4V415.9Z'
            mask='url(#path-404-inside-108_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint106_angular_3383_10956_clip_path'>
          <path
            d='M263.3 416.9V417.9H264.3V416.9H263.3ZM262.3 383V416.9H264.3V383H262.3ZM263.3 415.9H229.4V417.9H263.3V415.9Z'
            mask='url(#path-407-inside-109_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint107_angular_3383_10956_clip_path'>
          <path
            d='M297.2 416.9V417.9H298.2V416.9H297.2ZM296.2 383V416.9H298.2V383H296.2ZM297.2 415.9H263.3V417.9H297.2V415.9Z'
            mask='url(#path-410-inside-110_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint108_angular_3383_10956_clip_path'>
          <path
            d='M331.1 416.9V417.9H332.1V416.9H331.1ZM330.1 383V416.9H332.1V383H330.1ZM331.1 415.9H297.2V417.9H331.1V415.9Z'
            mask='url(#path-413-inside-111_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint109_angular_3383_10956_clip_path'>
          <path
            d='M365 416.9V417.9H366V416.9H365ZM364 383V416.9H366V383H364ZM365 415.9H331.1V417.9H365V415.9Z'
            mask='url(#path-416-inside-112_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint110_angular_3383_10956_clip_path'>
          <path
            d='M59.9 450.9V451.9H60.9V450.9H59.9ZM26 450.9H25V451.9H26V450.9ZM58.9 417V450.9H60.9V417H58.9ZM59.9 449.9H26V451.9H59.9V449.9ZM27 450.9V417H25V450.9H27Z'
            mask='url(#path-419-inside-113_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint111_angular_3383_10956_clip_path'>
          <path
            d='M93.8 450.9V451.9H94.8V450.9H93.8ZM92.8 417V450.9H94.8V417H92.8ZM93.8 449.9H59.9V451.9H93.8V449.9Z'
            mask='url(#path-422-inside-114_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint112_angular_3383_10956_clip_path'>
          <path
            d='M127.7 450.9V451.9H128.7V450.9H127.7ZM126.7 417V450.9H128.7V417H126.7ZM127.7 449.9H93.8V451.9H127.7V449.9Z'
            mask='url(#path-425-inside-115_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint113_angular_3383_10956_clip_path'>
          <path
            d='M161.6 450.9V451.9H162.6V450.9H161.6ZM160.6 417V450.9H162.6V417H160.6ZM161.6 449.9H127.7V451.9H161.6V449.9Z'
            mask='url(#path-428-inside-116_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint114_angular_3383_10956_clip_path'>
          <path
            d='M195.5 450.9V451.9H196.5V450.9H195.5ZM194.5 417V450.9H196.5V417H194.5ZM195.5 449.9H161.6V451.9H195.5V449.9Z'
            mask='url(#path-431-inside-117_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint115_angular_3383_10956_clip_path'>
          <path
            d='M229.4 450.9V451.9H230.4V450.9H229.4ZM228.4 417V450.9H230.4V417H228.4ZM229.4 449.9H195.5V451.9H229.4V449.9Z'
            mask='url(#path-434-inside-118_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint116_angular_3383_10956_clip_path'>
          <path
            d='M263.3 450.9V451.9H264.3V450.9H263.3ZM262.3 417V450.9H264.3V417H262.3ZM263.3 449.9H229.4V451.9H263.3V449.9Z'
            mask='url(#path-437-inside-119_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint117_angular_3383_10956_clip_path'>
          <path
            d='M297.2 450.9V451.9H298.2V450.9H297.2ZM296.2 417V450.9H298.2V417H296.2ZM297.2 449.9H263.3V451.9H297.2V449.9Z'
            mask='url(#path-440-inside-120_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint118_angular_3383_10956_clip_path'>
          <path
            d='M331.1 450.9V451.9H332.1V450.9H331.1ZM330.1 417V450.9H332.1V417H330.1ZM331.1 449.9H297.2V451.9H331.1V449.9Z'
            mask='url(#path-443-inside-121_3383_10956)'
          />
        </clipPath>
        <clipPath id='paint119_angular_3383_10956_clip_path'>
          <path
            d='M365 450.9V451.9H366V450.9H365ZM364 417V450.9H366V417H364ZM365 449.9H331.1V451.9H365V449.9Z'
            mask='url(#path-446-inside-122_3383_10956)'
          />
        </clipPath>
        <clipPath id='bgblur_0_3383_10956_clip_path' transform='translate(-48.2885 -62.2499)'>
          <rect
            width='24.3882'
            height='24.3882'
            transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 75.0779 64.6533)'
          />
        </clipPath>
        <clipPath id='bgblur_1_3383_10956_clip_path' transform='translate(-47.6351 -111.022)'>
          <rect
            width='24.3882'
            height='24.3882'
            transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 74.4245 113.425)'
          />
        </clipPath>
        <clipPath id='bgblur_2_3383_10956_clip_path' transform='translate(-23.2496 -110.695)'>
          <rect
            width='24.3882'
            height='24.3882'
            transform='matrix(-0.99991 -0.0133936 -0.0133936 0.99991 50.039 113.099)'
          />
        </clipPath>
        <clipPath id='bgblur_3_3383_10956_clip_path' transform='translate(-313.828 -341.25)'>
          <rect
            x='315.905'
            y='343.653'
            width='24.3882'
            height='24.3882'
            transform='rotate(-0.767422 315.905 343.653)'
          />
        </clipPath>
        <clipPath id='bgblur_4_3383_10956_clip_path' transform='translate(-314.482 -390.022)'>
          <rect
            x='316.559'
            y='392.425'
            width='24.3882'
            height='24.3882'
            transform='rotate(-0.767422 316.559 392.425)'
          />
        </clipPath>
        <clipPath id='bgblur_5_3383_10956_clip_path' transform='translate(-338.867 -389.695)'>
          <rect
            x='340.944'
            y='392.099'
            width='24.3882'
            height='24.3882'
            transform='rotate(-0.767422 340.944 392.099)'
          />
        </clipPath>
        <linearGradient
          id='paint120_linear_3383_10956'
          x1='196.703'
          y1='303.493'
          x2='196.703'
          y2='198.387'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FAFAFA' />
          <stop offset='1' stopColor='#FAFAFA' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  )
}
